import { print } from 'graphql'
import GetUsersGql from '~/graphql/documents/GetUsers.graphql'
import GetUserGql from '~/graphql/documents/GetUser.graphql'
import CreateUserGql from '~/graphql/documents/CreateUser.graphql'
import UpdateUserGql from '~/graphql/documents/UpdateUser.graphql'
import DeleteUserGql from '~/graphql/documents/DeleteUser.graphql'
import ArchiveUserGql from '~/graphql/documents/ArchiveUser.graphql'
import GetNewsItemTypesGql from '~/graphql/documents/news-items/GetNewsItemTypes.graphql'
import GetNewsItemsGql from '~/graphql/documents/news-items/GetNewsItems.graphql'
import GetNewsItemGql from '~/graphql/documents/news-items/GetNewsItem.graphql'
import CreateNewsItemGql from '~/graphql/documents/news-items/CreateNewsItem.graphql'
import UpdateNewsItemGql from '~/graphql/documents/news-items/UpdateNewsItem.graphql'
import DeleteNewsItemGql from '~/graphql/documents/news-items/DeleteNewsItem.graphql'
import GetCharityCategoriesGql from '~/graphql/documents/recommendations/GetCharityCategories.graphql'
import GetCharityCategoryGql from '~/graphql/documents/recommendations/GetCharityCategory.graphql'
import CreateCharityCategoryGql from '~/graphql/documents/recommendations/CreateCharityCategory.graphql'
import UpdateCharityCategoryGql from '~/graphql/documents/recommendations/UpdateCharityCategory.graphql'
import DeleteCharityCategoryGql from '~/graphql/documents/recommendations/DeleteCharityCategory.graphql'
import GetPersonalisedHifoRecommendationsGql from '~/graphql/documents/recommendations/GetPersonalisedHifoRecommendations.graphql'
import GetHifoAutofillGql from '~/graphql/documents/hifo-management/GetHifoAutofill.graphql'
import GetHifoGql from '~/graphql/documents/hifo-management/GetHifo.graphql'
import GetHifosGql from '~/graphql/documents/hifo-management/GetHifos.graphql'
import CreateHifoGql from '~/graphql/documents/hifo-management/CreateHifo.graphql'
import EditHifoGql from '~/graphql/documents/hifo-management/EditHifo.graphql'
import DeleteHifoGql from '~/graphql/documents/hifo-management/DeleteHifo.graphql'
import GetHifoCascadesGql from '~/graphql/documents/hifo-cascades/GetHifoCascades.graphql'
import GetHifoCascadeGql from '~/graphql/documents/hifo-cascades/GetHifoCascade.graphql'
import CreateHifoCascadeGql from '~/graphql/documents/hifo-cascades/CreateHifoCascade.graphql'
import UpdateHifoCascadeGql from '~/graphql/documents/hifo-cascades/UpdateHifoCascade.graphql'
import CreateHifoCascadePitchGql from '~/graphql/documents/hifo-cascades/CreateHifoCascadePitch.graphql'
import DeleteHifoCascadePitchGql from '~/graphql/documents/hifo-cascades/DeleteHifoCascadePitch.graphql'
import UpdateHifoCascadePitchGql from '~/graphql/documents/hifo-cascades/UpdateHifoCascadePitch.graphql'
import DeleteHifoCascadeGql from '~/graphql/documents/hifo-cascades/DeleteHifoCascade.graphql'
import ReorderHifoCascadePitchesGql from '~/graphql/documents/hifo-cascades/ReorderHifoCascadePitches.graphql'
import CreateHifoCascadePitchNoteGql from '~/graphql/documents/hifo-cascades/CreateHifoCascadePitchNote.graphql'
import DeleteHifoCascadePitchNoteGql from '~/graphql/documents/hifo-cascades/DeleteHifoCascadePitchNote.graphql'
import CreateHifoCascadePitchMaterialGql from '~/graphql/documents/hifo-cascades/CreateHifoCascadePitchMaterial.graphql'
import DeleteHifoCascadePitchMaterialGql from '~/graphql/documents/hifo-cascades/DeleteHifoCascadePitchMaterial.graphql'
import CreateImpactRecordGql from '~/graphql/documents/recommendations/CreateImpactRecord.graphql'
import UpdateImpactRecordGql from '~/graphql/documents/recommendations/UpdateImpactRecord.graphql'
import GetGrantBasketItemsGql from '~/graphql/documents/GetGrantBasketItems.graphql'
import GetPledgesGql from '~/graphql/documents/pledges/GetPledges.graphql'
import GetPledgeGql from '~/graphql/documents/pledges/GetPledge.graphql'
import CreatePledgeGql from '~/graphql/documents/pledges/CreatePledge.graphql'
import UpdatePledgeGql from '~/graphql/documents/pledges/UpdatePledge.graphql'
import DeleteProvisionalPledgeGql from '~/graphql/documents/pledges/DeleteProvisionalPledge.graphql'
import GetAmendedPledgeGql from '~/graphql/documents/pledges/GetAmendedPledge.graphql'
import GetAmendedPledgesGql from '~/graphql/documents/pledges/GetAmendedPledges.graphql'
import UpdateAmendedPledgeGql from '~/graphql/documents/pledges/UpdateAmendedPledge.graphql'
import { appFetch } from '~/services/appFetch'
import GetSessionInfoGql from '~/graphql/documents/GetSessionInfo.graphql'
import GetGlobalSearchGql from '~/graphql/documents/global-search/GetGlobalSearch.graphql'
import CreateSecondFactorGql from '~/graphql/documents/two-factor/CreateSecondFactor.graphql'
import DisableSecondFactorGql from '~/graphql/documents/two-factor/DisableSecondFactor.graphql'
import EnableSecondFactorGql from '~/graphql/documents/two-factor/EnableSecondFactor.graphql'
import RemoveSecondFactorsGql from '~/graphql/documents/two-factor/RemoveSecondFactors.graphql'
import CreateImpactMeasurementCategoryGql from '~/graphql/documents/impact/CreateImpactMeasurementCategory.graphql'
import UpdateImpactMeasurementCategoryGql from '~/graphql/documents/impact/UpdateImpactMeasurementCategory.graphql'
import DeleteImpactMeasurementCategoryGql from '~/graphql/documents/impact/DeleteImpactMeasurementCategory.graphql'
import GetImpactMeasurementCategoryGql from '~/graphql/documents/impact/GetImpactMeasurementCategory.graphql'
import GetImpactMeasurementCategoriesGql from '~/graphql/documents/impact/GetImpactMeasurementCategories.graphql'
import CreateImpactMeasurementItemGql from '~/graphql/documents/impact/CreateImpactMeasurementItem.graphql'
import UpdateImpactMeasurementItemGql from '~/graphql/documents/impact/UpdateImpactMeasurementItem.graphql'
import DeleteImpactMeasurementItemGql from '~/graphql/documents/impact/DeleteImpactMeasurementItem.graphql'
import GetTargetAudiencesGql from '~/graphql/documents/target-audiences/GetTargetAudiences.graphql'
import GetTargetAudienceGql from '~/graphql/documents/target-audiences/GetTargetAudience.graphql'
import CreateTargetAudienceGql from '~/graphql/documents/target-audiences/CreateTargetAudience.graphql'
import UpdateTargetAudienceGql from '~/graphql/documents/target-audiences/UpdateTargetAudience.graphql'
import DeleteTargetAudienceGql from '~/graphql/documents/target-audiences/DeleteTargetAudience.graphql'
import GetMatchCampaignsGql from '~/graphql/documents/match-campaigns/GetMatchCampaigns.graphql'
import GetMatchCampaignGql from '~/graphql/documents/match-campaigns/GetMatchCampaign.graphql'
import CreateMatchCampaignGql from '~/graphql/documents/match-campaigns/CreateMatchCampaign.graphql'
import UpdateMatchCampaignGql from '~/graphql/documents/match-campaigns/UpdateMatchCampaign.graphql'
import DeleteMatchCampaignGql from '~/graphql/documents/match-campaigns/DeleteMatchCampaign.graphql'
import GetMatchCampaignCategoriesGql from '~/graphql/documents/match-campaigns/GetMatchCampaignCategories.graphql'
import GetMatchCampaignCategoryGql from '~/graphql/documents/match-campaigns/GetMatchCampaignCategory.graphql'
import CreateMatchCampaignCategoryGql from '~/graphql/documents/match-campaigns/CreateMatchCampaignCategory.graphql'
import UpdateMatchCampaignCategoryGql from '~/graphql/documents/match-campaigns/UpdateMatchCampaignCategory.graphql'
import DeleteMatchCampaignCategoryGql from '~/graphql/documents/match-campaigns/DeleteMatchCampaignCategory.graphql'
import GetCaseProcessingRecordsGql from '~/graphql/documents/case-reporting/GetCaseProcessingRecords.graphql'
import GetDafStatementPeriodsGql from '~/graphql/documents/daf-statements/GetDafStatementPeriods.graphql'
import GetDafStatementsGql from '~/graphql/documents/daf-statements/GetDafStatements.graphql'
import GenerateAllDafStatementsGql from '~/graphql/documents/daf-statements/GenerateAllDafStatements.graphql'
import PublishDafStatementsGql from '~/graphql/documents/daf-statements/PublishDafStatements.graphql'
import RegenerateDafStatementsGql from '~/graphql/documents/daf-statements/RegenerateDafStatements.graphql'
import GetSageGiftAccountsGql from '~/graphql/documents/sage-salesforce/GetSageGiftAccounts.graphql'
import GetSageGiftAccountGql from '~/graphql/documents/sage-salesforce/GetSageGiftAccount.graphql'
import GetSageGiftAccountRecordsGql from '~/graphql/documents/sage-salesforce/GetSageGiftAccountRecords.graphql'
import GetSageJournalEntriesGql from '~/graphql/documents/sage-salesforce/GetSageJournalEntries.graphql'
import LinkSageTransactionRecordGql from '~/graphql/documents/sage-salesforce/LinkSageTransactionRecord.graphql'
import GetGiftAccountBalancesGql from '~/graphql/documents/sage-salesforce/GetGiftAccountBalances.graphql'
import RunBalanceReconciliationGql from '~/graphql/documents/sage-salesforce/RunBalanceReconciliation.graphql'
import GetBalanceReconciliationTransactionsGql from '~/graphql/documents/sage-salesforce/GetBalanceReconciliationTransactions.graphql'
import GetSageGiftAccountDifferencesGql from '~/graphql/documents/sage-salesforce/GetSageGiftAccountDifferences.graphql'
import GetSageGiftAccountDifferenceCountsGql from '~/graphql/documents/sage-salesforce/GetSageGiftAccountDifferenceCounts.graphql'
import AcceptSageGiftAccountDifferencesGql from '~/graphql/documents/sage-salesforce/AcceptSageGiftAccountDifferences.graphql'
import IgnoreSageGiftAccountDifferencesGql from '~/graphql/documents/sage-salesforce/IgnoreSageGiftAccountDifferences.graphql'
import ReopenSageGiftAccountDifferencesGql from '~/graphql/documents/sage-salesforce/ReopenSageGiftAccountDifferences.graphql'
import SyncSageRecordsGql from '~/graphql/documents/sage-salesforce/SyncSageRecords.graphql'
import UpdateSageGiftAccountRecordGql from '~/graphql/documents/sage-salesforce/UpdateSageGiftAccountRecord.graphql'
import GetInvestmentDailyBalancesGql from '~/graphql/documents/investments/GetInvestmentDailyBalances.graphql'
import GetInvestmentPoolsGql from '~/graphql/documents/investments/GetInvestmentPools.graphql'
import CreateInvestmentPoolGql from '~/graphql/documents/investments/CreateInvestmentPool.graphql'
import UpdateInvestmentPoolGql from '~/graphql/documents/investments/UpdateInvestmentPool.graphql'
import DeleteInvestmentPoolGql from '~/graphql/documents/investments/DeleteInvestmentPool.graphql'
import LockInvestmentPeriodGql from '~/graphql/documents/investments/LockInvestmentPeriod.graphql'
import GetInvestmentPeriodsGql from '~/graphql/documents/investments/GetInvestmentPeriods.graphql'
import GetInvestmentPoolPerformancesGql from '~/graphql/documents/investments/GetInvestmentPoolPerformances.graphql'
import UpdateInvestmentPoolPerformanceGql from '~/graphql/documents/investments/UpdateInvestmentPoolPerformance.graphql'
import GetInvestmentAccountPerformancesGql from '~/graphql/documents/investments/GetInvestmentAccountPerformances.graphql'
import GenerateSalesforceCasesForAccountPerformanceGql from '~/graphql/documents/investments/GenerateSalesforceCasesForAccountPerformance.graphql'
import GenerateSalesforceCasesForPeriodGql from '~/graphql/documents/investments/GenerateSalesforceCasesForPeriod.graphql'
import GetEmployeesGql from '~/graphql/documents/employees/GetEmployees.graphql'
import UpdateEmployeeGql from '~/graphql/documents/employees/UpdateEmployee.graphql'
import SetEmployeeLeavingGql from '~/graphql/documents/employees/SetEmployeeLeaving.graphql'
import AddNewStarterGql from '~/graphql/documents/employees/AddNewStarter.graphql'
import CreateTeamGql from '~/graphql/documents/teams/CreateTeam.graphql'
import GetTeamsGql from '~/graphql/documents/teams/GetTeams.graphql'
import UpdateTeamGql from '~/graphql/documents/teams/UpdateTeam.graphql'
import SearchAssetsGql from '~/graphql/documents/assets/SearchAssets.graphql'
import GetAssetGql from '~/graphql/documents/assets/GetAsset.graphql'
import GetAssetDeviceCheckSummaryGql from '~/graphql/documents/assets/GetAssetDeviceCheckSummary.graphql'
import CreateAssetGql from '~/graphql/documents/assets/CreateAsset.graphql'
import CreateAssetsFromOrderGql from '~/graphql/documents/assets/CreateAssetsFromOrder.graphql'
import UpdateAssetGql from '~/graphql/documents/assets/UpdateAsset.graphql'
import AssignAssetGql from '~/graphql/documents/assets/AssignAsset.graphql'
import ReturnAssetGql from '~/graphql/documents/assets/ReturnAsset.graphql'
import ChangeAssetStatusGql from '~/graphql/documents/assets/ChangeAssetStatus.graphql'
import DeleteAssetDocumentGql from '~/graphql/documents/assets/DeleteAssetDocument.graphql'
import AddAssetSecretGql from '~/graphql/documents/assets/AddAssetSecret.graphql'
import RevealAssetSecretGql from '~/graphql/documents/assets/RevealAssetSecret.graphql'
import RecordAssetCheckGql from '~/graphql/documents/assets/RecordAssetCheck.graphql'
import SearchContractsGql from '~/graphql/documents/contracts/SearchContracts.graphql'
import GetContractSummaryGql from '~/graphql/documents/contracts/GetContractSummary.graphql'
import GetContractGql from '~/graphql/documents/contracts/GetContract.graphql'
import CreateContractGql from '~/graphql/documents/contracts/CreateContract.graphql'
import UpdateContractGql from '~/graphql/documents/contracts/UpdateContract.graphql'
import RecordContractRenewalDecisionGql from '~/graphql/documents/contracts/RecordContractRenewalDecision.graphql'
import TerminateContractGql from '~/graphql/documents/contracts/TerminateContract.graphql'
import DeleteContractDocumentGql from '~/graphql/documents/contracts/DeleteContractDocument.graphql'
import DeleteContractGql from '~/graphql/documents/contracts/DeleteContract.graphql'
import ReadContractDocumentAgainGql from '~/graphql/documents/contracts/ReadContractDocumentAgain.graphql'
import GetAssetReturnsGql from '~/graphql/documents/assets/GetAssetReturns.graphql'
import SetAssetExpectedReturnGql from '~/graphql/documents/assets/SetAssetExpectedReturn.graphql'
import GetRolesGql from '~/graphql/documents/roles/GetRoles.graphql'
import GetRoleGql from '~/graphql/documents/roles/GetRole.graphql'
import EditRoleGql from '~/graphql/documents/roles/EditRole.graphql'
import CreateRoleGql from '~/graphql/documents/roles/CreateRole.graphql'
import GetPermissionsGql from '~/graphql/documents/permissions/GetPermissions.graphql'
import GetFundGroupsGql from '~/graphql/documents/funds/GetFundGroups.graphql'
import GetFundGroupGql from '~/graphql/documents/funds/GetFundGroup.graphql'
import GetFundsGql from '~/graphql/documents/funds/GetFunds.graphql'
import GetFundAccountsGql from '~/graphql/documents/funds/GetFundAccounts.graphql'
import GetFundGql from '~/graphql/documents/funds/GetFund.graphql'
import GetLegalEntitiesGql from '~/graphql/documents/funds/GetLegalEntities.graphql'
import GetLegalEntityByNameGql from '~/graphql/documents/funds/GetLegalEntityByName.graphql'
import GetFundRecordTypesGql from '~/graphql/documents/funds/GetFundRecordTypes.graphql'
import GetDafAdminFeePeriodsGql from '~/graphql/documents/daf-fees/GetDafAdminFeePeriods.graphql'
import GetAdminFeeSageJournalEntryGql from '~/graphql/documents/daf-fees/GetAdminFeeSageJournalEntry.graphql'
import GetAdminFeeSageJournalEntriesGql from '~/graphql/documents/daf-fees/GetAdminFeeSageJournalEntries.graphql'
import GetDafAdminFeePeriodGql from '~/graphql/documents/daf-fees/GetDafAdminFeePeriod.graphql'
import LockDafAdminFeePeriodGql from '~/graphql/documents/daf-fees/LockDafAdminFeePeriod.graphql'
import CompleteAdminFeeSageJournalEntryGql from '~/graphql/documents/daf-fees/CompleteAdminFeeSageJournalEntry.graphql'
import RecalculateDafAdminFeesGql from '~/graphql/documents/daf-fees/RecalculateDafAdminFees.graphql'
import GetDafPlanChangesGql from '~/graphql/documents/funds/GetDafPlanChanges.graphql'
import GetDafInvestmentAllocationChangesGql from '~/graphql/documents/funds/GetDafInvestmentAllocationChanges.graphql'
import UpdateFundsDafPlanGql from '~/graphql/documents/funds/UpdateFundsDafPlan.graphql'
import UpdateFundsDafInvestmentAllocationGql from '~/graphql/documents/funds/UpdateFundsDafInvestmentAllocation.graphql'
import GetCharitiesGql from '~/graphql/documents/charities/GetCharities.graphql'
import GetCharityGql from '~/graphql/documents/charities/GetCharity.graphql'
import GetCharityChariotDisbursementsGql from '~/graphql/documents/charities/GetCharityChariotDisbursements.graphql'
import GetUsDueDiligenceGql from '~/graphql/documents/us-due-diligences/GetUsDueDiligence.graphql'
import UpdateUsDueDiligenceGql from '~/graphql/documents/us-due-diligences/UpdateUsDueDiligence.graphql'
import UpdateZeroHarmReviewGql from '~/graphql/documents/us-due-diligences/UpdateZeroHarmReview.graphql'
import GetDafAdminFeesForFundGql from '~/graphql/documents/daf-fees/GetDafAdminFeesForFund.graphql'
import GetCompaniesGql from '~/graphql/documents/companies/GetCompanies.graphql'
import GetCompanyGql from '~/graphql/documents/companies/GetCompany.graphql'
import GetCompanyRecordTypesGql from '~/graphql/documents/companies/GetCompanyRecordTypes.graphql'
import GetContactsGql from '~/graphql/documents/contacts/GetContacts.graphql'
import GetContactGql from '~/graphql/documents/contacts/GetContact.graphql'
import GetContactRecordTypesGql from '~/graphql/documents/contacts/GetContactRecordTypes.graphql'
import GetSearchEmployeesGql from '~/graphql/documents/employees/GetSearchEmployees.graphql'
import GetEmployeeGql from '~/graphql/documents/employees/GetEmployee.graphql'
import GetEmployeeKitGql from '~/graphql/documents/employees/GetEmployeeKit.graphql'
import GetCaseTypesGql from '~/graphql/documents/case-records/GetCaseTypes.graphql'
import GetCaseRecordsGql from '~/graphql/documents/case-records/GetCaseRecords.graphql'
import GetGrantsGql from '~/graphql/documents/case-records/GetGrants.graphql'
import GetCaseRecordGql from '~/graphql/documents/case-records/GetCaseRecord.graphql'
import UpdateCaseRecordGql from '~/graphql/documents/case-records/UpdateCaseRecord.graphql'
import UpdateGrantCaseRecordGql from '~/graphql/documents/case-records/UpdateGrantCaseRecord.graphql'
import CreateUsDisbursementGql from '~/graphql/documents/case-records/CreateUsDisbursement.graphql'
import CancelGrantGql from '~/graphql/documents/case-records/CancelGrant.graphql'
import SnoozeGrantGql from '~/graphql/documents/case-records/SnoozeGrant.graphql'
import UnsnoozeGrantGql from '~/graphql/documents/case-records/UnsnoozeGrant.graphql'
import ProcessCaseRecordGrantComplianceGql from '~/graphql/documents/case-records/ProcessCaseRecordGrantCompliance.graphql'
import CreateCaseNoteGql from '~/graphql/documents/case-records/CreateCaseNote.graphql'
import UpdateCaseNoteGql from '~/graphql/documents/case-records/UpdateCaseNote.graphql'
import DeleteCaseNoteGql from '~/graphql/documents/case-records/DeleteCaseNote.graphql'
import CreateUsDueDiligenceNoteGql from '~/graphql/documents/us-due-diligences/CreateUsDueDiligenceNote.graphql'
import UpdateUsDueDiligenceNoteGql from '~/graphql/documents/us-due-diligences/UpdateUsDueDiligenceNote.graphql'
import DeleteUsDueDiligenceNoteGql from '~/graphql/documents/us-due-diligences/DeleteUsDueDiligenceNote.graphql'
import UpdateGrantComplianceCheckGql from '~/graphql/documents/case-records/UpdateGrantComplianceCheck.graphql'
import GetAttachmentsInfoGql from '~/graphql/documents/funds/GetAttachmentsInfo.graphql'
import type { AttachmentRecordType } from '~/composables/useAttachments'
import GetRelatedCasesGql from '~/graphql/documents/related-cases/GetRelatedCases.graphql'
import GetCaseRecordAccountingHistoryGql from '~/graphql/documents/case-records/GetCaseRecordAccountingHistory.graphql'
import GetFundAccountAverageMonthlyBalancesGql from '~/graphql/documents/funds/GetFundAccountAverageMonthlyBalances.graphql'
import GetDataUploadsGql from '~/graphql/documents/data-uploads/GetDataUploads.graphql'
import GetDataUploadGql from '~/graphql/documents/data-uploads/GetDataUpload.graphql'
import GetRequestsForFundingGql from '~/graphql/documents/requests-for-funding/GetRequestsForFunding.graphql'
import GetRequestForFundingGql from '~/graphql/documents/requests-for-funding/GetRequestForFunding.graphql'
import GetDataUploadRowsGql from '~/graphql/documents/data-uploads/GetDataUploadRows.graphql'
import ChangeDataUploadRowDecisionGql from '~/graphql/documents/data-uploads/ChangeDataUploadRowDecision.graphql'
import CreateDataUploadRowRecordGql from '~/graphql/documents/data-uploads/CreateDataUploadRowRecord.graphql'
import CreateAllDataUploadRowRecordsGql from '~/graphql/documents/data-uploads/CreateAllDataUploadRowRecords.graphql'
import RunDuplicateCheckerGql from '~/graphql/documents/data-uploads/RunDuplicateChecker.graphql'
import GetSageSalesforceMetricGql from '~/graphql/documents/sage-salesforce/GetSageSalesforceMetric.graphql'
import GetSageJournalEntryGql from '~/graphql/documents/sage-salesforce/GetSageJournalEntry.graphql'
import GetPotentialMatchesGql from '~/graphql/documents/sage-salesforce/GetPotentialMatches.graphql'
import GetExchangeRatesGql from '~/graphql/documents/exchange-rates/GetExchangeRates.graphql'
import GetDafAdvisorExternalOpexDonationsGql from '~/graphql/documents/daf-fees/GetDafAdvisorExternalOpexDonations.graphql'
import GetCharityBankAccountsGql from '~/graphql/documents/bank-accounts/GetCharityBankAccounts.graphql'
import GetCharityBankAccountGql from '~/graphql/documents/bank-accounts/GetCharityBankAccount.graphql'
import GetCharityContactsGql from '~/graphql/documents/charity-contacts/GetCharityContacts.graphql'
import GetCharityContactInvitationsGql from '~/graphql/documents/charity-contacts/GetCharityContactInvitations.graphql'
import InviteCharityContactGql from '~/graphql/documents/charity-contacts/InviteCharityContact.graphql'
import DeactivateCharityContactGql from '~/graphql/documents/charity-contacts/DeactivateCharityContact.graphql'
import UpdateCharityContactGql from '~/graphql/documents/charity-contacts/UpdateCharityContact.graphql'
import CreateCharityBankAccountVerificationCallGql from '~/graphql/documents/bank-accounts/CreateCharityBankAccountVerificationCall.graphql'
import UpdateCharityBankAccountStatusGql from '~/graphql/documents/bank-accounts/UpdateCharityBankAccountStatus.graphql'
import UpsertCharityBankAccountChecklistItemGql from '~/graphql/documents/bank-accounts/UpsertCharityBankAccountChecklistItem.graphql'
import CancelCharityContactInviteGql from '~/graphql/documents/charity-contacts/CancelCharityContactInvite.graphql'
import ResendCharityContactInviteGql from '~/graphql/documents/charity-contacts/ResendCharityContactInvite.graphql'
import GetEventsGql from '~/graphql/documents/events/GetEvents.graphql'
import GetEventsSummaryGql from '~/graphql/documents/events/GetEventsSummary.graphql'
import GetEventGql from '~/graphql/documents/events/GetEvent.graphql'
import CreateEventGql from '~/graphql/documents/events/CreateEvent.graphql'
import UpdateEventGql from '~/graphql/documents/events/UpdateEvent.graphql'
import GetMyTrainingGql from '~/graphql/documents/training/GetMyTraining.graphql'
import GetMyTrainingModuleGql from '~/graphql/documents/training/GetMyTrainingModule.graphql'
import GetMyTrainingCourseGql from '~/graphql/documents/training/GetMyTrainingCourse.graphql'
import StartTrainingCourseGql from '~/graphql/documents/training/StartTrainingCourse.graphql'
import CompleteTrainingModuleGql from '~/graphql/documents/training/CompleteTrainingModule.graphql'
import GetMyQuizAttemptGql from '~/graphql/documents/training/GetMyQuizAttempt.graphql'
import RecordTrainingVideoProgressGql from '~/graphql/documents/training/RecordTrainingVideoProgress.graphql'
import AcknowledgeTrainingPoliciesGql from '~/graphql/documents/training/AcknowledgeTrainingPolicies.graphql'
import StartTrainingQuizAttemptGql from '~/graphql/documents/training/StartTrainingQuizAttempt.graphql'
import SubmitTrainingQuizAttemptGql from '~/graphql/documents/training/SubmitTrainingQuizAttempt.graphql'
import GetTrainingComplianceSummaryGql from '~/graphql/documents/training-admin/GetTrainingComplianceSummary.graphql'
import SearchTrainingComplianceGql from '~/graphql/documents/training-admin/SearchTrainingCompliance.graphql'
import GetTrainingEmployeeDetailGql from '~/graphql/documents/training-admin/GetTrainingEmployeeDetail.graphql'
import SearchTrainingOutOfScopeGql from '~/graphql/documents/training-admin/SearchTrainingOutOfScope.graphql'
import GetTrainingModulesGql from '~/graphql/documents/training-admin/GetTrainingModules.graphql'
import GetTrainingModuleGql from '~/graphql/documents/training-admin/GetTrainingModule.graphql'
import GetPoliciesGql from '~/graphql/documents/training-admin/GetPolicies.graphql'
import GetPolicyRegisterGql from '~/graphql/documents/training-admin/GetPolicyRegister.graphql'
import GetPolicyGql from '~/graphql/documents/training-admin/GetPolicy.graphql'
import GetCurrentPolicyDocumentGql from '~/graphql/documents/training-admin/GetCurrentPolicyDocument.graphql'
import CreateTrainingModuleGql from '~/graphql/documents/training-admin/CreateTrainingModule.graphql'
import UpdateTrainingModuleGql from '~/graphql/documents/training-admin/UpdateTrainingModule.graphql'
import PublishTrainingModuleGql from '~/graphql/documents/training-admin/PublishTrainingModule.graphql'
import ArchiveTrainingModuleGql from '~/graphql/documents/training-admin/ArchiveTrainingModule.graphql'
import ReorderTrainingModulesGql from '~/graphql/documents/training-admin/ReorderTrainingModules.graphql'
import GetTrainingCoursesGql from '~/graphql/documents/training-admin/GetTrainingCourses.graphql'
import GetTrainingCourseGql from '~/graphql/documents/training-admin/GetTrainingCourse.graphql'
import GetTrainingCourseProgressGql from '~/graphql/documents/training-admin/GetTrainingCourseProgress.graphql'
import CreateTrainingCourseGql from '~/graphql/documents/training-admin/CreateTrainingCourse.graphql'
import UpdateTrainingCourseGql from '~/graphql/documents/training-admin/UpdateTrainingCourse.graphql'
import PublishTrainingCourseGql from '~/graphql/documents/training-admin/PublishTrainingCourse.graphql'
import ArchiveTrainingCourseGql from '~/graphql/documents/training-admin/ArchiveTrainingCourse.graphql'
import ReorderTrainingCourseModulesGql from '~/graphql/documents/training-admin/ReorderTrainingCourseModules.graphql'
import ReorderTrainingCoursesGql from '~/graphql/documents/training-admin/ReorderTrainingCourses.graphql'
import GetTrainingCategoriesGql from '~/graphql/documents/training-admin/GetTrainingCategories.graphql'
import CreateTrainingCategoryGql from '~/graphql/documents/training-admin/CreateTrainingCategory.graphql'
import UpdateTrainingCategoryGql from '~/graphql/documents/training-admin/UpdateTrainingCategory.graphql'
import UpsertTrainingQuestionGql from '~/graphql/documents/training-admin/UpsertTrainingQuestion.graphql'
import SetTrainingQuestionActiveGql from '~/graphql/documents/training-admin/SetTrainingQuestionActive.graphql'
import CreatePolicyGql from '~/graphql/documents/training-admin/CreatePolicy.graphql'
import UpdatePolicyGql from '~/graphql/documents/training-admin/UpdatePolicy.graphql'
import RecordPolicyReviewGql from '~/graphql/documents/training-admin/RecordPolicyReview.graphql'
import ReadPolicyDocumentAgainGql from '~/graphql/documents/training-admin/ReadPolicyDocumentAgain.graphql'
import DismissPolicySummarySuggestionGql from '~/graphql/documents/training-admin/DismissPolicySummarySuggestion.graphql'
import AssignTrainingModuleGql from '~/graphql/documents/training-admin/AssignTrainingModule.graphql'
import RequireTrainingRetakeGql from '~/graphql/documents/training-admin/RequireTrainingRetake.graphql'
import UpdateTrainingAssignmentGql from '~/graphql/documents/training-admin/UpdateTrainingAssignment.graphql'
import UpdateEmployeeTrainingFieldsGql from '~/graphql/documents/training-admin/UpdateEmployeeTrainingFields.graphql'
import RecordPolicyAcknowledgementGql from '~/graphql/documents/training-admin/RecordPolicyAcknowledgement.graphql'
import GrantAdminPortalAccessGql from '~/graphql/documents/employees/GrantAdminPortalAccess.graphql'
import GetTrainingNudgesGql from '~/graphql/documents/training-admin/GetTrainingNudges.graphql'
import SendTrainingNudgesGql from '~/graphql/documents/training-admin/SendTrainingNudges.graphql'
import UpdateAttendeeStatusGql from '~/graphql/documents/events/UpdateAttendeeStatus.graphql'
import PromoteFromWaitlistGql from '~/graphql/documents/events/PromoteFromWaitlist.graphql'
import ResendConfirmationGql from '~/graphql/documents/events/ResendConfirmation.graphql'
import SendHeldUpdatesGql from '~/graphql/documents/events/SendHeldUpdates.graphql'
import DiscardHeldUpdatesGql from '~/graphql/documents/events/DiscardHeldUpdates.graphql'
import AddPlusOneGql from '~/graphql/documents/events/AddPlusOne.graphql'
import GetEventCheckInGql from '~/graphql/documents/events/GetEventCheckIn.graphql'
import CheckInAttendeeGql from '~/graphql/documents/events/CheckInAttendee.graphql'
import UndoCheckInGql from '~/graphql/documents/events/UndoCheckIn.graphql'
import CloseCheckInGql from '~/graphql/documents/events/CloseCheckIn.graphql'
import SendEventFollowUpsGql from '~/graphql/documents/events/SendEventFollowUps.graphql'
import SetEarlyAccessGql from '~/graphql/documents/events/SetEarlyAccess.graphql'
import SendEventReminderGql from '~/graphql/documents/events/SendEventReminder.graphql'
import InviteGuestsGql from '~/graphql/documents/events/InviteGuests.graphql'
import ResolveContactDifferencesGql from '~/graphql/documents/events/ResolveContactDifferences.graphql'
import UpdateAttendeeDetailsGql from '~/graphql/documents/events/UpdateAttendeeDetails.graphql'
import GetEventAttendeeGql from '~/graphql/documents/events/GetEventAttendee.graphql'
import RegisterAttendeesGql from '~/graphql/documents/events/RegisterAttendees.graphql'
import SendTestEventEmailGql from '~/graphql/documents/events/SendTestEventEmail.graphql'
import GetCampaignsGql from '~/graphql/documents/events/GetCampaigns.graphql'
import CreateEventCampaignGql from '~/graphql/documents/events/CreateEventCampaign.graphql'
import GetEventQuestionTemplatesGql from '~/graphql/documents/events/GetEventQuestionTemplates.graphql'
import GetEventWebsitePageStatusGql from '~/graphql/documents/events/GetEventWebsitePageStatus.graphql'
import UpsertEventQuestionTemplateGql from '~/graphql/documents/events/UpsertEventQuestionTemplate.graphql'
import GetEventSettingsGql from '~/graphql/documents/events/GetEventSettings.graphql'
import UpdateEventSettingsGql from '~/graphql/documents/events/UpdateEventSettings.graphql'
import type {
  AmendedPledgeAdmin,
  AmendedPledgeAdminCollection,
  GetAttachmentsInfoQuery,
  QueryAdminAttachmentsArgs,
  SfAttachments,
  CaseProcessingRecord,
  CharityCategoryAdmin,
  CharityCategoryChangeInput,
  CharityCategoryAdminCollection,
  CreateCharityCategoryMutation,
  CreateImpactMeasurementCategoryMutation,
  CreateImpactMeasurementItemMutation,
  CreateImpactRecordMutation,
  CreateInvestmentPoolMutationVariables,
  CreateMatchCampaignCategoryInput,
  CreateMatchCampaignCategoryMutation,
  CreateMatchCampaignInput,
  CreateMatchCampaignMutation,
  CreateNewsItemMutation,
  CreatePledgeInput,
  CreatePledgeMutation,
  CreateSecondFactorPayload,
  CreateTargetAudienceInput,
  CreateTargetAudienceMutation,
  CreateUsDisbursementMutation,
  CreateUserInput,
  CreateUserMutation,
  DafStatement,
  DafStatementInput,
  DafStatementPeriod,
  DeleteInvestmentPoolMutationVariables,
  DeleteProvisionalPledgeInput,
  DisableSecondFactorInput,
  Employee,
  EnableSecondFactorInput,
  AttendeeDetailsInput,
  EventAdmin,
  GetMyTrainingQuery,
  GetMyTrainingModuleQuery,
  GetMyTrainingCourseQuery,
  StartTrainingCourseMutation,
  CompleteTrainingModuleMutation,
  ReorderTrainingCoursesMutation,
  GetTrainingCategoriesQuery,
  CreateTrainingCategoryMutation,
  UpdateTrainingCategoryMutation,
  TrainingCategoryFieldsFragment,
  GetTrainingCoursesQuery,
  GetTrainingCourseQuery,
  GetTrainingCourseProgressQuery,
  TrainingCourseAdminFieldsFragment,
  CreateTrainingCourseMutation,
  UpdateTrainingCourseMutation,
  PublishTrainingCourseMutation,
  ArchiveTrainingCourseMutation,
  ReorderTrainingCourseModulesMutation,
  TrainingCourseInput,
  GetMyQuizAttemptQuery,
  RecordTrainingVideoProgressMutation,
  AcknowledgeTrainingPoliciesMutation,
  StartTrainingQuizAttemptMutation,
  SubmitTrainingQuizAttemptMutation,
  StaffQuizAttemptFieldsFragment,
  StaffTrainingModuleFieldsFragment,
  StaffTrainingPolicyFieldsFragment,
  QuizAnswerInput,
  GetTrainingComplianceSummaryQuery,
  SearchTrainingComplianceQuery,
  SearchTrainingComplianceQueryVariables,
  GetTrainingEmployeeDetailQuery,
  SearchTrainingOutOfScopeQuery,
  SearchTrainingOutOfScopeQueryVariables,
  GetTrainingModulesQuery,
  GetTrainingModuleQuery,
  GetPoliciesQuery,
  GetPolicyQuery,
  GetPolicyRegisterQuery,
  GetCurrentPolicyDocumentQuery,
  ReadPolicyDocumentAgainMutation,
  DismissPolicySummarySuggestionMutation,
  CreateTrainingModuleMutation,
  UpdateTrainingModuleMutation,
  PublishTrainingModuleMutation,
  ArchiveTrainingModuleMutation,
  ReorderTrainingModulesMutation,
  UpsertTrainingQuestionMutation,
  UpsertTrainingQuestionMutationVariables,
  SetTrainingQuestionActiveMutation,
  CreatePolicyMutation,
  UpdatePolicyMutation,
  RecordPolicyReviewMutation,
  RecordPolicyReviewInput,
  AssignTrainingModuleMutation,
  RequireTrainingRetakeMutation,
  UpdateTrainingAssignmentMutation,
  UpdateTrainingAssignmentMutationVariables,
  UpdateEmployeeTrainingFieldsMutation,
  UpdateEmployeeTrainingFieldsMutationVariables,
  TrainingModuleAdminFieldsFragment,
  PolicyAdminFieldsFragment,
  TrainingModuleInput,
  PolicyInput,
  GetTrainingNudgesQuery,
  GetTrainingNudgesQueryVariables,
  SendTrainingNudgesMutation,
  EventAdminCollection,
  EventAttendeeStatusEnum,
  EventChangeInput,
  EventPeriodEnum,
  EventQuestionTemplate,
  EventsSummary,
  EventTypeEnum,
  GetEventsSummaryQuery,
  GetEventQuestionTemplatesQuery,
  GetEventWebsitePageStatusQuery,
  EventWebsitePageStatusEnum,
  GetEventSettingsQuery,
  RegisterAttendeesMutation,
  GetEventCheckInQuery,
  CheckInAttendeeMutation,
  UndoCheckInMutation,
  CloseCheckInMutation,
  SendEventFollowUpsMutation,
  SetEarlyAccessMutation,
  SendEventReminderMutation,
  InviteGuestsMutation,
  EventContactFieldEnum,
  AttendeeDetailsChangesInput,
  GetEventAttendeeQuery,
  EventFollowUpSegmentEnum,
  EventReminderKindEnum,
  RegistrationTargetEnum,
  SendTestEventEmailMutation,
  GetCampaignsQuery,
  GetCampaignsQueryVariables,
  CreateEventCampaignMutation,
  UpsertEventQuestionTemplateMutation,
  UpsertEventQuestionTemplateMutationVariables,
  UpdateEventSettingsMutation,
  UpdateEventSettingsMutationVariables,
  EventStatusEnum,
  CreateEventMutation,
  GetEventQuery,
  GetEventsQuery,
  PromoteFromWaitlistMutation,
  QueryAdminEventArgs,
  QueryAdminEventsArgs,
  UpdateAttendeeStatusInput,
  UpdateEventMutation,
  GenerateAllDafStatementsInput,
  GenerateAllDafStatementsMutation,
  GenerateSalesforceCasesForAccountPerformanceInput,
  GenerateSalesforceCasesForPeriodInput,
  GetAmendedPledgeQuery,
  GetAmendedPledgesQuery,
  GetCaseProcessingRecordsQuery,
  GetCharityCategoriesQuery,
  GetCharityCategoryQuery,
  GetDafStatementPeriodsQuery,
  GetDafStatementsQuery,
  GetPersonalisedHifoRecommendationsQuery,
  GetPersonalisedHifoRecommendationsQueryVariables,
  GetGrantBasketItemsQuery,
  GetImpactMeasurementCategoriesQuery,
  GetImpactMeasurementCategoryQuery,
  GetMatchCampaignCategoriesQuery,
  GetMatchCampaignCategoryQuery,
  GetMatchCampaignQuery,
  GetMatchCampaignsQuery,
  GetNewsItemQuery,
  GetNewsItemsQuery,
  GetNewsItemTypesQuery,
  GetPledgeQuery,
  GetPledgesQuery,
  GetSessionInfoQuery,
  GetGlobalSearchQuery,
  QueryAdminGlobalSearchArgs,
  GlobalSearchHit,
  GetTargetAudienceQuery,
  GetTargetAudiencesQuery,
  GetUserQuery,
  GetUsersQuery,
  GiftAccountBalance,
  GivingPreferencesInput,
  GrantBasketItemAdminCollection,
  GrantBasketItemsSearchEnum,
  GrantComplianceCheck,
  ImpactMeasurementCategory,
  ImpactMeasurementCategoryInput,
  ImpactMeasurementItemInput,
  ImpactRecordInput,
  InvestmentAccountPerformance,
  InvestmentPeriod,
  InvestmentPool,
  InvestmentPoolInput,
  InvestmentPoolPerformance,
  InvestmentPoolPerformanceInput,
  LinkSageTransactionRecordMutationVariables,
  LockInvestmentPeriodMutationVariables,
  MatchCampaignAdmin,
  MatchCampaignCategory,
  MatchCampaignCategoryInput,
  MatchCampaignInput,
  NewsItemAdmin,
  NewsItemAdminCollection,
  NewsItemChangeInput,
  NewsItemEvent,
  PledgeAdmin,
  PledgeAdminCollection,
  PledgeSearchEnum,
  PublishDafStatementsInput,
  PublishDafStatementsMutation,
  QueryAdminCaseProcessingRecordsArgs,
  QueryAdminCharityCategoriesArgs,
  QueryAdminCharityCategoryArgs,
  QueryAdminDafStatementsArgs,
  QueryAdminGrantBasketItemsArgs,
  QueryAdminImpactMeasurementCategoryArgs,
  QueryAdminMatchCampaignArgs,
  QueryAdminMatchCampaignCategoryArgs,
  QueryAdminNewsItemArgs,
  QueryAdminNewsItemsArgs,
  QueryAdminPledgeArgs,
  QueryAdminPledgesArgs,
  QueryAdminTargetAudienceArgs,
  QueryAdminUserArgs,
  QueryAdminUsersArgs,
  RegenerateDafStatementsInput,
  RegenerateDafStatementsMutation,
  RemoveSecondFactorsInput,
  RemoveSecondFactorsMutation,
  SageGiftAccount,
  SyncSageRecordsMutationVariables,
  TargetAudience,
  TargetAudienceInput,
  UpdateAmendedPledgeInput,
  UpdateCharityCategoryInput,
  ProcessCaseRecordGrantComplianceMutation,
  UpdateGrantComplianceCheckInput,
  UpdateGrantComplianceCheckMutation,
  UpdateUsDueDiligenceInput,
  UpdateUsDueDiligenceMutation,
  UpdateZeroHarmReviewInput,
  UpdateImpactMeasurementCategoryInput,
  UpdateImpactMeasurementItemInput,
  UpdateImpactRecordInput,
  UpdateInvestmentPoolMutationVariables,
  UpdateInvestmentPoolPerformanceMutationVariables,
  UpdateMatchCampaignCategoryInput,
  UpdateMatchCampaignInput,
  UpdateNewsItemInput,
  UpdatePledgeInput,
  UpdateTargetAudienceInput,
  UpdateUserInput,
  User,
  UserCollection,
  FundCollection,
  QueryAdminFundsArgs,
  GetFundsQuery,
  Fund,
  QueryAdminFundArgs,
  GetFundQuery,
  FundGroup,
  QueryAdminFundGroupsArgs,
  GetFundGroupsQuery,
  FundGroupCollection,
  QueryAdminFundGroupArgs,
  GetFundGroupQuery,
  FundRecord,
  LegalEntityAdmin,
  DafAdminFeePeriodCollection,
  GetDafAdminFeePeriodsQuery,
  QueryAdminDafAdminFeePeriodsArgs,
  DafAdminFeePeriod,
  QueryAdminDafAdminFeePeriodArgs,
  GetDafAdminFeePeriodQuery,
  GetLegalEntityByNameQuery,
  QueryAdminLegalEntityByNameArgs,
  StringFilterInput,
  NumericFilterInput,
  DateFilterInput,
  GetDafPlanChangesQuery,
  DafPlanChangeCollection,
  DafInvestmentAllocationChangeCollection,
  QueryAdminDafPlanChangesArgs,
  CharityStringFilterInput,
  CharityCollection,
  GetCharitiesQuery,
  QueryAdminCharitiesArgs,
  Charity,
  UsDueDiligence,
  QueryAdminCharityArgs,
  GetCharityQuery,
  GetCharityChariotDisbursementsQuery,
  ChariotDisbursement,
  QueryAdminDafAdminFeesForFundArgs,
  GetDafAdminFeesForFundQuery,
  CompanyAdmin,
  GetCompanyQuery,
  QueryAdminCompanyArgs,
  CompanyStringFilterInput,
  CompanyAdminCollection,
  GetCompaniesQuery,
  QueryAdminCompaniesArgs,
  ContactStringFilterInput,
  ContactCollection,
  QueryAdminContactsArgs,
  GetContactsQuery,
  QueryAdminContactArgs,
  Contact,
  GetContactQuery,
  CompanyRecord,
  ContactRecord,
  EmployeeCollection,
  EmployeeStringFilterInput,
  QueryAdminSearchEmployeesArgs,
  GetSearchEmployeesQuery,
  GetEmployeeQuery,
  GetEmployeeQueryVariables,
  GetEmployeeKitQuery,
  SetEmployeeLeavingMutation,
  SetEmployeeLeavingMutationVariables,
  EmployeeBooleanFilterInput,
  CaseRecordCollection,
  GetCaseRecordsQuery,
  QueryAdminCaseRecordsArgs,
  GetGrantsQuery,
  QueryAdminGrantsArgs,
  GrantCaseRecordStatusEnum,
  CaseType,
  CaseRecordFilterGroupInput,
  GrantFilterGroupInput,
  CaseRecord,
  GetCaseRecordQuery,
  QueryAdminCaseRecordArgs,
  RelatedCase,
  GetRelatedCaseRecordsQuery,
  GetCaseRecordAccountingHistoryQuery,
  QueryAdminCaseRecordAccountingHistoryArgs,
  InvestmentDailyBalance,
  QueryAdminInvestmentDailyBalancesArgs,
  QueryAdminRelatedCaseRecordsArgs,
  QueryAdminDafInvestmentAllocationChangesArgs,
  GetDafInvestmentAllocationChangesQuery,
  UpdateFundsDafPlanInput,
  UpdateFundsDafPlanPayload,
  UpdateFundsDafInvestmentAllocationInput,
  UpdateFundsDafInvestmentAllocationPayload,
  QueryAdminFundAccountAverageMonthlyBalancesArgs,
  GetFundAccountAverageMonthlyBalancesQuery,
  FundAccountAverageMonthlyBalanceCollection,
  QueryAdminDataUploadsArgs,
  DataUploadCollection,
  GetDataUploadsQuery,
  DataUpload,
  QueryAdminDataUploadArgs,
  GetDataUploadQuery,
  DataUploadRowDecision,
  ChangeDataUploadRowDecisionMutationVariables,
  CreateDataUploadRowRecordMutationVariables,
  DataUploadRow,
  QueryAdminDataUploadRowsArgs,
  GetDataUploadRowsQuery,
  GetRequestsForFundingQuery,
  GetRequestForFundingQuery,
  QueryAdminRequestsForFundingArgs,
  QueryAdminRequestForFundingArgs,
  RequestForFunding,
  RequestForFundingCollection,
  RequestForFundingFormTypeEnum,
  CreateAllDataUploadRowRecordsMutationVariables,
  RunDuplicateCheckerMutationVariables,
  QueryAdminFundAccountsArgs,
  GetFundAccountsQuery,
  FundAccountCollection,
  GetAdminFeeSageJournalEntriesQuery,
  QueryAdminAdminFeeSageJournalEntriesArgs,
  AdminFeeSageJournalEntryCollection,
  QueryAdminAdminFeeSageJournalEntryArgs,
  GetAdminFeeSageJournalEntryQuery,
  AdminFeeSageJournalEntry,
  SageGiftAccountFilterConditionInput,
  SageGiftAccountCollection,
  QueryAdminSageGiftAccountRecordsArgs,
  GetSageGiftAccountRecordsQuery,
  QueryAdminSageGiftAccountArgs,
  GetSageGiftAccountQuery,
  UpdateSageGiftAccountRecordMutationVariables,
  QueryAdminSageJournalEntriesArgs,
  SageJournalEntryFilterConditionInput,
  SageJournalEntryCollection,
  GetSageJournalEntriesQuery,
  SageSalesforceMetric,
  SageSalesforceMetricTypeEnum,
  QueryAdminSageSalesforceMetricArgs,
  SageJournalEntry,
  QueryAdminSageJournalEntryArgs,
  GetSageJournalEntryQuery,
  PotentialMatch,
  QueryAdminPotentialMatchesArgs,
  QueryAdminGiftAccountBalancesArgs,
  QueryAdminBalanceReconciliationArgs,
  BalanceReconciliationResult,
  QueryAdminBalanceReconciliationTransactionsArgs,
  BalanceReconciliationTransactions,
  QueryAdminSageGiftAccountDifferencesArgs,
  SageGiftAccountDifferenceCollection,
  SageGiftAccountDifferenceCounts,
  SageGiftAccountDifferenceActionResult,
  FundAdminFee,
  ExchangeRateCollection,
  QueryAdminExchangeRatesArgs,
  GetExchangeRatesQuery,
  QueryAdminDafAdvisorExternalOpexDonationsArgs,
  DafAdvisorExternalOpexDonation,
  GetDafAdvisorExternalOpexDonationsQuery,
  HifoAdmin,
  HifoChangeInput,
  HifoAdminCollection,
  HifoStatus,
  HifoTypeEnum,
  GetHifosQuery,
  CreateHifoMutation,
  GetHifoQuery,
  GetHifoQueryVariables,
  HifoCascade,
  HifoCascadeChangeInput,
  HifoCascadeCollection,
  GetHifoCascadesQuery,
  GetHifoCascadeQuery,
  CreateHifoCascadeMutation,
  UpdateHifoCascadeMutation,
  HifoCascadePitchChangeInput,
  CreateHifoCascadePitchMutation,
  DeleteHifoCascadePitchMutation,
  UpdateHifoCascadePitchMutation,
  DeleteHifoCascadeMutation,
  ResendCharityContactInviteInput,
  CancelCharityContactInviteInput,
  UpdateCharityContactInput,
  DeactivateCharityContactInput,
  AdminCharityContact,
  AdminCharityContactInvitation,
  AdminCharityBankAccount,
  AdminCharityBankAccountChecklistItem,
  CharityContactInvitationListStatusEnum,
  GetCharityContactsQuery,
  GetCharityContactInvitationsQuery,
  QueryAdminCharityBankAccountsArgs,
  QueryAdminCharityContactsArgs,
  QueryAdminCharityContactInvitationsArgs,
  InviteCharityContactInput,
  EditHifoMutation,
  UpdateCharityBankAccountStatusInput,
  UpsertCharityBankAccountChecklistItemInput,
  QueryAdminCharityBankAccountArgs,
  Role,
  EmployeeChangeInput,
  AddNewStarterMutation,
  AddNewStarterMutationVariables,
  CreateTeamMutation,
  GetTeamsQuery,
  TeamFieldsFragment,
  AssetFieldsFragment,
  SearchAssetsQuery,
  SearchAssetsQueryVariables,
  GetAssetQuery,
  GetAssetDeviceCheckSummaryQuery,
  CreateAssetMutation,
  CreateAssetMutationVariables,
  CreateAssetsFromOrderMutation,
  CreateAssetsFromOrderMutationVariables,
  UpdateAssetMutation,
  AssetAttributesInput,
  AssignAssetMutation,
  AssignAssetMutationVariables,
  ReturnAssetMutation,
  ReturnAssetMutationVariables,
  ChangeAssetStatusMutation,
  ChangeAssetStatusMutationVariables,
  DeleteAssetDocumentMutation,
  AddAssetSecretMutation,
  AddAssetSecretMutationVariables,
  RevealAssetSecretMutation,
  RecordAssetCheckMutation,
  RecordAssetCheckMutationVariables,
  AssetDocumentKindEnum,
  ContractFieldsFragment,
  SearchContractsQuery,
  SearchContractsQueryVariables,
  GetContractSummaryQuery,
  GetContractQuery,
  CreateContractMutation,
  CreateContractMutationVariables,
  UpdateContractMutation,
  UpdateContractMutationVariables,
  RecordContractRenewalDecisionMutation,
  RecordContractRenewalDecisionMutationVariables,
  TerminateContractMutation,
  TerminateContractMutationVariables,
  DeleteContractDocumentMutation,
  DeleteContractMutation,
  ReadContractDocumentAgainMutation,
  ContractDocumentKindEnum,
  GetAssetReturnsQuery,
  SetAssetExpectedReturnMutation,
  AssetReturnMethodEnum,
  UpdateTeamMutation,
  UpdateTeamMutationVariables,
  RoleInput,
  Permission,
  UpdateCaseRecordInput,
  UpdateGrantCaseRecordInput,
  QueryAdminHifoAutofillArgs,
} from '~~/models/graphql/generated/types'

import {
  NewsItemsSearchEnum,
  UserSearchEnum,
} from '~~/models/graphql/generated/types'
import { useUserSessionStore } from '~/store/user-session'
import { assigned } from '~/services/object-utilities'

export class GraphQlUnexpectedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'GraphQlUnexpectedError'
  }
}

export class GraphQlError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'GraphQlError'
  }
}

export type TrainingMediaKind = 'video' | 'captions' | 'poster'

export type TrainingMediaResult = {
  id: string
  hasVideo: boolean
  hasCaptions: boolean
  hasPoster: boolean
  videoDurationSeconds: number | null
}

export type TrainingCourseMediaResult = { id: string; hasPoster: boolean }

export class BffClient {
  /**
   * This method handles GraphQL error response automatically.
   * GraphQL returns 200 status code on error.
   *
   * We could explore the option of using Vue Apollo or using
   * graphql-request if this is becoming more complex.
   */
  private async request(query: string, variables?: Record<string, unknown>) {
    const { token } = useAuth()

    const response = await appFetch(
      `/graphql-admin`,
      token.value ?? undefined,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query, variables }),
      }
    )
    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    try {
      // The server may extend the token length. If it does the response will contain a http header "Expires".
      // This expires header is the number of seconds from now to extend the session by.
      if (
        assigned(response?.headers.has('expires')) &&
        response.headers.get('expires')
      ) {
        // Nuxt auth sets the expiration time based on the number of milliseconds from the epoch
        // The steps below take the new expires time and turns it into milliseconds and adds it to now.
        const tokenTTLSeconds = Number(response.headers.get('expires'))
        // Set the expiration token
        useUserSessionStore().setSessionSecondsRemaining(tokenTTLSeconds)
      }
    } catch (e) {
      console.error(e)
    }

    if (!response.ok) {
      throw new GraphQlUnexpectedError(
        `Failed to execute GraphQL query: ${response.statusText}`
      )
    }
    const data = await response.json()
    if (data.errors) {
      throw new GraphQlError(
        data.errors.map((m: { message: string }) => m.message).join(', ')
      )
    }
    return data
  }

  async getUsers(
    page: number,
    limit: number,
    search: string | undefined,
    searchType: UserSearchEnum = UserSearchEnum.All,
    sortBy: string | undefined
  ): Promise<UserCollection> {
    const response = await this.request(print(GetUsersGql), {
      page,
      limit,
      search,
      searchType,
      sortBy,
    } as QueryAdminUsersArgs)

    const data = response.data as GetUsersQuery

    return <UserCollection>data.users
  }

  async getUser(id: string): Promise<User> {
    const response = await this.request(print(GetUserGql), {
      id,
    } as QueryAdminUserArgs)

    const data = response.data as GetUserQuery

    return <User>data.user
  }

  async createUser(input: CreateUserInput): Promise<string> {
    const response = await this.request(print(CreateUserGql), input)
    const data = response.data as CreateUserMutation
    return data?.createUser?.user?.id as string
  }

  async updateUser(input: UpdateUserInput): Promise<void> {
    await this.request(print(UpdateUserGql), input)
  }

  async deleteUser(id: string): Promise<void> {
    await this.request(print(DeleteUserGql), { id })
  }

  async archiveUser(
    id: string,
    employeeLeft?: { leftOn: string | null }
  ): Promise<void> {
    await this.request(print(ArchiveUserGql), {
      id,
      markEmployeeLeft: Boolean(employeeLeft),
      leftOn: employeeLeft?.leftOn ?? null,
    })
  }

  async getGrantBasketItems(
    page: number,
    limit: number,
    search: string | undefined,
    status: GrantBasketItemsSearchEnum
  ): Promise<GrantBasketItemAdminCollection> {
    const response = await this.request(print(GetGrantBasketItemsGql), {
      page,
      limit,
      search,
      status,
    } as QueryAdminGrantBasketItemsArgs)

    const data = response.data as GetGrantBasketItemsQuery

    return <GrantBasketItemAdminCollection>data.grantBasketItems
  }

  async getPledges(
    page: number,
    limit: number,
    search: string | undefined,
    status: PledgeSearchEnum
  ): Promise<PledgeAdminCollection> {
    const response = await this.request(print(GetPledgesGql), {
      page,
      limit,
      search,
      status,
    } as QueryAdminPledgesArgs)

    const data = response.data as GetPledgesQuery

    return <PledgeAdminCollection>data.pledges
  }

  async getPledge(id: string): Promise<PledgeAdmin> {
    const response = await this.request(print(GetPledgeGql), {
      id,
    } as QueryAdminPledgeArgs)

    const data = response.data as GetPledgeQuery

    return <PledgeAdmin>data.pledge
  }

  async updatePledge(input: UpdatePledgeInput): Promise<void> {
    await this.request(print(UpdatePledgeGql), input)
  }

  async deleteProvisionalPledge(
    input: DeleteProvisionalPledgeInput
  ): Promise<void> {
    await this.request(print(DeleteProvisionalPledgeGql), input)
  }

  async createPledge(input: CreatePledgeInput): Promise<string> {
    const response = await this.request(print(CreatePledgeGql), input)
    const data = response.data as CreatePledgeMutation
    return data?.createPledge?.pledge?.id as string
  }

  async getAmendedPledges(
    page: number,
    limit: number,
    search: string | undefined,
    status: PledgeSearchEnum
  ): Promise<AmendedPledgeAdminCollection> {
    const response = await this.request(print(GetAmendedPledgesGql), {
      page,
      limit,
      search,
      status,
    } as QueryAdminPledgesArgs)

    const data = response.data as GetAmendedPledgesQuery
    return <AmendedPledgeAdminCollection>data.amendedPledges
  }

  async getAmendedPledge(id: string): Promise<AmendedPledgeAdmin> {
    const response = await this.request(print(GetAmendedPledgeGql), {
      id,
    } as QueryAdminPledgeArgs)

    const data = response.data as GetAmendedPledgeQuery

    return <AmendedPledgeAdmin>data.amendedPledge
  }

  async updateAmendedPledge(input: UpdateAmendedPledgeInput): Promise<void> {
    await this.request(print(UpdateAmendedPledgeGql), input)
  }

  async getSessionInfo(): Promise<User> {
    const response = await this.request(print(GetSessionInfoGql))

    const data = response.data as GetSessionInfoQuery

    return <User>data.sessionInfo
  }

  async globalSearch(
    query: string,
    limitPerType?: number
  ): Promise<GlobalSearchHit[]> {
    const response = await this.request(print(GetGlobalSearchGql), {
      query,
      limitPerType,
    } as QueryAdminGlobalSearchArgs)

    const data = response.data as GetGlobalSearchQuery

    return data.globalSearch as GlobalSearchHit[]
  }

  async createSecondFactor(): Promise<CreateSecondFactorPayload> {
    const response = await this.request(print(CreateSecondFactorGql))
    return response.data.createSecondFactor as CreateSecondFactorPayload
  }

  async enableSecondFactor(input: EnableSecondFactorInput): Promise<void> {
    await this.request(print(EnableSecondFactorGql), input)
  }

  async disableSecondFactor(input: DisableSecondFactorInput): Promise<void> {
    await this.request(print(DisableSecondFactorGql), input)
  }

  async removeSecondFactors(userId: string, code: string): Promise<boolean> {
    const response = await this.request(print(RemoveSecondFactorsGql), {
      userId,
      code,
    } as RemoveSecondFactorsInput)

    const data = response.data as RemoveSecondFactorsMutation
    return data?.removeSecondFactors?.success ?? false
  }

  async getNewsItemTypes(): Promise<NewsItemEvent[]> {
    const response = await this.request(print(GetNewsItemTypesGql))

    const data = response.data as GetNewsItemTypesQuery

    return <NewsItemEvent[]>data.newsItemTypes
  }

  async getNewsItems(
    page: number,
    limit: number,
    search: string | undefined,
    searchFilter: NewsItemsSearchEnum = NewsItemsSearchEnum.CurrentAndFuture
  ): Promise<NewsItemAdminCollection> {
    const response = await this.request(print(GetNewsItemsGql), {
      page,
      limit,
      search,
      searchFilter,
    } as QueryAdminNewsItemsArgs)

    const data = response.data as GetNewsItemsQuery

    return <NewsItemAdminCollection>data.newsItems
  }

  async getNewsItem(id: string): Promise<NewsItemAdmin> {
    const response = await this.request(print(GetNewsItemGql), {
      id,
    } as QueryAdminNewsItemArgs)

    const data = response.data as GetNewsItemQuery

    return <NewsItemAdmin>data.newsItem
  }

  async createNewsItem(input: NewsItemChangeInput): Promise<string> {
    const response = await this.request(print(CreateNewsItemGql), {
      newsItemChanges: input,
    })
    const data = response.data as CreateNewsItemMutation
    return data?.createNewsItem?.newsItem?.id as string
  }

  async updateNewsItem(
    newsItemId: string,
    input: NewsItemChangeInput
  ): Promise<void> {
    await this.request(print(UpdateNewsItemGql), {
      newsItemId,
      newsItemChanges: input,
    } as UpdateNewsItemInput)
  }

  async deleteNewsItem(id: string): Promise<void> {
    await this.request(print(DeleteNewsItemGql), { id })
  }

  async getEvents(
    page: number,
    limit: number,
    filters: {
      status?: EventStatusEnum
      eventType?: EventTypeEnum
      period?: EventPeriodEnum
      city?: string
      search?: string
    } = {}
  ): Promise<EventAdminCollection> {
    const response = await this.request(print(GetEventsGql), {
      page,
      limit,
      ...filters,
    } as QueryAdminEventsArgs)

    const data = response.data as GetEventsQuery

    return <EventAdminCollection>data.events
  }

  async getEventsSummary(): Promise<EventsSummary> {
    const response = await this.request(print(GetEventsSummaryGql))
    const data = response.data as GetEventsSummaryQuery
    return data.eventsSummary
  }

  async getEvent(id: string): Promise<EventAdmin> {
    const response = await this.request(print(GetEventGql), {
      id,
    } as QueryAdminEventArgs)

    const data = response.data as GetEventQuery

    return <EventAdmin>data.event
  }

  async createEvent(input: EventChangeInput): Promise<string> {
    const response = await this.request(print(CreateEventGql), {
      eventChanges: input,
    })
    const data = response.data as CreateEventMutation
    return data?.createEvent?.event?.id as string
  }

  async updateEvent(eventId: string, input: EventChangeInput): Promise<string> {
    const response = await this.request(print(UpdateEventGql), {
      eventId,
      eventChanges: input,
    })
    const data = response.data as UpdateEventMutation
    return data?.updateEvent?.event?.id as string
  }

  async getMyTraining(): Promise<GetMyTrainingQuery['myTraining']> {
    const response = await this.request(print(GetMyTrainingGql))
    return (response.data as GetMyTrainingQuery).myTraining
  }

  async getMyTrainingModule(
    slug: string
  ): Promise<StaffTrainingModuleFieldsFragment> {
    const response = await this.request(print(GetMyTrainingModuleGql), {
      slug,
    })
    return (response.data as GetMyTrainingModuleQuery).myTrainingModule
  }

  async getMyTrainingCourse(
    slug: string
  ): Promise<GetMyTrainingCourseQuery['myTrainingCourse']> {
    const response = await this.request(print(GetMyTrainingCourseGql), {
      slug,
    })
    return (response.data as GetMyTrainingCourseQuery).myTrainingCourse
  }

  async startTrainingCourse(
    slug: string
  ): Promise<
    StartTrainingCourseMutation['startTrainingCourse']['trainingCourse']
  > {
    const response = await this.request(print(StartTrainingCourseGql), {
      slug,
    })
    return (response.data as StartTrainingCourseMutation).startTrainingCourse
      .trainingCourse
  }

  async completeTrainingModule(
    moduleId: string
  ): Promise<StaffTrainingModuleFieldsFragment> {
    const response = await this.request(print(CompleteTrainingModuleGql), {
      moduleId,
    })
    return (response.data as CompleteTrainingModuleMutation)
      .completeTrainingModule.trainingModule
  }

  async getMyQuizAttempt(id: string): Promise<StaffQuizAttemptFieldsFragment> {
    const response = await this.request(print(GetMyQuizAttemptGql), { id })
    return (response.data as GetMyQuizAttemptQuery).myQuizAttempt
  }

  async recordTrainingVideoProgress(
    moduleId: string,
    percent: number
  ): Promise<StaffTrainingModuleFieldsFragment> {
    const response = await this.request(print(RecordTrainingVideoProgressGql), {
      moduleId,
      percent,
    })
    return (response.data as RecordTrainingVideoProgressMutation)
      .recordTrainingVideoProgress.trainingModule
  }

  async acknowledgeTrainingPolicies(
    policyIds: string[]
  ): Promise<StaffTrainingPolicyFieldsFragment[]> {
    const response = await this.request(print(AcknowledgeTrainingPoliciesGql), {
      policyIds,
    })
    return (response.data as AcknowledgeTrainingPoliciesMutation)
      .acknowledgeTrainingPolicies.policies
  }

  async startTrainingQuizAttempt(
    moduleId: string
  ): Promise<StaffQuizAttemptFieldsFragment> {
    const response = await this.request(print(StartTrainingQuizAttemptGql), {
      moduleId,
    })
    return (response.data as StartTrainingQuizAttemptMutation)
      .startTrainingQuizAttempt.attempt
  }

  async submitTrainingQuizAttempt(
    attemptId: string,
    answers: QuizAnswerInput[]
  ): Promise<StaffQuizAttemptFieldsFragment> {
    const response = await this.request(print(SubmitTrainingQuizAttemptGql), {
      attemptId,
      answers,
    })
    return (response.data as SubmitTrainingQuizAttemptMutation)
      .submitTrainingQuizAttempt.attempt
  }

  async getTrainingComplianceSummary(
    categoryId?: string | null
  ): Promise<GetTrainingComplianceSummaryQuery> {
    const response = await this.request(
      print(GetTrainingComplianceSummaryGql),
      {
        categoryId,
      }
    )
    return response.data as GetTrainingComplianceSummaryQuery
  }

  async searchTrainingCompliance(
    args: SearchTrainingComplianceQueryVariables
  ): Promise<SearchTrainingComplianceQuery['searchTrainingCompliance']> {
    const response = await this.request(
      print(SearchTrainingComplianceGql),
      args
    )
    return (response.data as SearchTrainingComplianceQuery)
      .searchTrainingCompliance
  }

  async getTrainingEmployeeDetail(
    employeeId: string
  ): Promise<GetTrainingEmployeeDetailQuery['trainingEmployeeDetail']> {
    const response = await this.request(print(GetTrainingEmployeeDetailGql), {
      employeeId,
    })
    return (response.data as GetTrainingEmployeeDetailQuery)
      .trainingEmployeeDetail
  }

  async searchTrainingOutOfScope(
    args: SearchTrainingOutOfScopeQueryVariables
  ): Promise<SearchTrainingOutOfScopeQuery['searchTrainingOutOfScope']> {
    const response = await this.request(
      print(SearchTrainingOutOfScopeGql),
      args
    )
    return (response.data as SearchTrainingOutOfScopeQuery)
      .searchTrainingOutOfScope
  }

  async getTrainingModules(): Promise<
    GetTrainingModulesQuery['trainingModules']
  > {
    const response = await this.request(print(GetTrainingModulesGql))
    return (response.data as GetTrainingModulesQuery).trainingModules
  }

  async getTrainingModule(
    id: string
  ): Promise<TrainingModuleAdminFieldsFragment> {
    const response = await this.request(print(GetTrainingModuleGql), { id })
    return (response.data as GetTrainingModuleQuery).trainingModule
  }

  async getPolicies(): Promise<PolicyAdminFieldsFragment[]> {
    const response = await this.request(print(GetPoliciesGql))
    return (response.data as GetPoliciesQuery).policies
  }

  async getPolicyRegister(): Promise<GetPolicyRegisterQuery> {
    const response = await this.request(print(GetPolicyRegisterGql))
    return response.data as GetPolicyRegisterQuery
  }

  async getPolicy(id: string): Promise<GetPolicyQuery['policy']> {
    const response = await this.request(print(GetPolicyGql), { id })
    return (response.data as GetPolicyQuery).policy
  }

  async getCurrentPolicyDocument(
    policyId: string
  ): Promise<GetCurrentPolicyDocumentQuery['currentPolicyDocument']> {
    const response = await this.request(print(GetCurrentPolicyDocumentGql), {
      policyId,
    })
    return (response.data as GetCurrentPolicyDocumentQuery)
      .currentPolicyDocument
  }

  async createTrainingModule(
    moduleInput: TrainingModuleInput,
    courseId?: string
  ): Promise<TrainingModuleAdminFieldsFragment> {
    const response = await this.request(print(CreateTrainingModuleGql), {
      moduleInput,
      courseId,
    })
    return (response.data as CreateTrainingModuleMutation).createTrainingModule
      .trainingModule
  }

  async updateTrainingModule(
    moduleId: string,
    moduleInput: TrainingModuleInput
  ): Promise<TrainingModuleAdminFieldsFragment> {
    const response = await this.request(print(UpdateTrainingModuleGql), {
      moduleId,
      moduleInput,
    })
    return (response.data as UpdateTrainingModuleMutation).updateTrainingModule
      .trainingModule
  }

  async publishTrainingModule(
    moduleId: string,
    dueOn?: string | null
  ): Promise<PublishTrainingModuleMutation['publishTrainingModule']> {
    const response = await this.request(print(PublishTrainingModuleGql), {
      moduleId,
      dueOn,
    })
    return (response.data as PublishTrainingModuleMutation)
      .publishTrainingModule
  }

  async archiveTrainingModule(
    moduleId: string
  ): Promise<TrainingModuleAdminFieldsFragment> {
    const response = await this.request(print(ArchiveTrainingModuleGql), {
      moduleId,
    })
    return (response.data as ArchiveTrainingModuleMutation)
      .archiveTrainingModule.trainingModule
  }

  async reorderTrainingModules(
    moduleIds: string[]
  ): Promise<
    ReorderTrainingModulesMutation['reorderTrainingModules']['trainingModules']
  > {
    const response = await this.request(print(ReorderTrainingModulesGql), {
      moduleIds,
    })
    return (response.data as ReorderTrainingModulesMutation)
      .reorderTrainingModules.trainingModules
  }

  async getTrainingCourses(
    categoryId?: string | null
  ): Promise<GetTrainingCoursesQuery['trainingCourses']> {
    const response = await this.request(print(GetTrainingCoursesGql), {
      categoryId,
    })
    return (response.data as GetTrainingCoursesQuery).trainingCourses
  }

  async reorderTrainingCourses(
    courseIds: string[]
  ): Promise<
    ReorderTrainingCoursesMutation['reorderTrainingCourses']['trainingCourses']
  > {
    const response = await this.request(print(ReorderTrainingCoursesGql), {
      courseIds,
    })
    return (response.data as ReorderTrainingCoursesMutation)
      .reorderTrainingCourses.trainingCourses
  }

  async getTrainingCategories(
    includeArchived = false
  ): Promise<TrainingCategoryFieldsFragment[]> {
    const response = await this.request(print(GetTrainingCategoriesGql), {
      includeArchived,
    })
    return (response.data as GetTrainingCategoriesQuery).trainingCategories
  }

  async createTrainingCategory(
    name: string
  ): Promise<TrainingCategoryFieldsFragment> {
    const response = await this.request(print(CreateTrainingCategoryGql), {
      name,
    })
    return (response.data as CreateTrainingCategoryMutation)
      .createTrainingCategory.trainingCategory
  }

  async updateTrainingCategory(
    id: string,
    changes: { name?: string; archived?: boolean }
  ): Promise<TrainingCategoryFieldsFragment> {
    const response = await this.request(print(UpdateTrainingCategoryGql), {
      id,
      ...changes,
    })
    return (response.data as UpdateTrainingCategoryMutation)
      .updateTrainingCategory.trainingCategory
  }

  async getTrainingCourse(
    id: string
  ): Promise<TrainingCourseAdminFieldsFragment> {
    const response = await this.request(print(GetTrainingCourseGql), { id })
    return (response.data as GetTrainingCourseQuery).trainingCourse
  }

  async getTrainingCourseProgress(
    courseId: string
  ): Promise<GetTrainingCourseProgressQuery['trainingCourseProgress']> {
    const response = await this.request(print(GetTrainingCourseProgressGql), {
      courseId,
    })
    return (response.data as GetTrainingCourseProgressQuery)
      .trainingCourseProgress
  }

  async createTrainingCourse(
    courseInput: TrainingCourseInput,
    singleModule = false
  ): Promise<CreateTrainingCourseMutation['createTrainingCourse']> {
    const response = await this.request(print(CreateTrainingCourseGql), {
      courseInput,
      singleModule,
    })
    return (response.data as CreateTrainingCourseMutation).createTrainingCourse
  }

  async updateTrainingCourse(
    courseId: string,
    courseInput: TrainingCourseInput
  ): Promise<TrainingCourseAdminFieldsFragment> {
    const response = await this.request(print(UpdateTrainingCourseGql), {
      courseId,
      courseInput,
    })
    return (response.data as UpdateTrainingCourseMutation).updateTrainingCourse
      .trainingCourse
  }

  async publishTrainingCourse(
    courseId: string
  ): Promise<PublishTrainingCourseMutation['publishTrainingCourse']> {
    const response = await this.request(print(PublishTrainingCourseGql), {
      courseId,
    })
    return (response.data as PublishTrainingCourseMutation)
      .publishTrainingCourse
  }

  async archiveTrainingCourse(
    courseId: string
  ): Promise<TrainingCourseAdminFieldsFragment> {
    const response = await this.request(print(ArchiveTrainingCourseGql), {
      courseId,
    })
    return (response.data as ArchiveTrainingCourseMutation)
      .archiveTrainingCourse.trainingCourse
  }

  async reorderTrainingCourseModules(
    courseId: string,
    moduleIds: string[]
  ): Promise<TrainingCourseAdminFieldsFragment> {
    const response = await this.request(
      print(ReorderTrainingCourseModulesGql),
      { courseId, moduleIds }
    )
    return (response.data as ReorderTrainingCourseModulesMutation)
      .reorderTrainingCourseModules.trainingCourse
  }

  async upsertTrainingQuestion(
    args: UpsertTrainingQuestionMutationVariables
  ): Promise<TrainingModuleAdminFieldsFragment> {
    const response = await this.request(print(UpsertTrainingQuestionGql), args)
    return (response.data as UpsertTrainingQuestionMutation)
      .upsertTrainingQuestion.trainingModule
  }

  async setTrainingQuestionActive(
    questionId: string,
    active: boolean
  ): Promise<TrainingModuleAdminFieldsFragment> {
    const response = await this.request(print(SetTrainingQuestionActiveGql), {
      questionId,
      active,
    })
    return (response.data as SetTrainingQuestionActiveMutation)
      .setTrainingQuestionActive.trainingModule
  }

  async createPolicy(
    policyInput: PolicyInput
  ): Promise<PolicyAdminFieldsFragment> {
    const response = await this.request(print(CreatePolicyGql), { policyInput })
    return (response.data as CreatePolicyMutation).createPolicy.policy
  }

  async updatePolicy(
    policyId: string,
    policyInput: PolicyInput
  ): Promise<PolicyAdminFieldsFragment> {
    const response = await this.request(print(UpdatePolicyGql), {
      policyId,
      policyInput,
    })
    return (response.data as UpdatePolicyMutation).updatePolicy.policy
  }

  async readPolicyDocumentAgain(
    documentId: string
  ): Promise<
    ReadPolicyDocumentAgainMutation['readPolicyDocumentAgain']['policy']
  > {
    const response = await this.request(print(ReadPolicyDocumentAgainGql), {
      documentId,
    })
    return (response.data as ReadPolicyDocumentAgainMutation)
      .readPolicyDocumentAgain.policy
  }

  async dismissPolicySummarySuggestion(
    documentId: string
  ): Promise<
    DismissPolicySummarySuggestionMutation['dismissPolicySummarySuggestion']['policy']
  > {
    const response = await this.request(
      print(DismissPolicySummarySuggestionGql),
      { documentId }
    )
    return (response.data as DismissPolicySummarySuggestionMutation)
      .dismissPolicySummarySuggestion.policy
  }

  // Uploads the official copy of a policy version: the current version unless another is named
  async uploadPolicyDocument(
    policyId: string,
    file: File,
    version?: string
  ): Promise<{
    id: string
    version: string
    originalFilename: string
    readingSummary: boolean
  }> {
    const formData = new FormData()
    formData.append('file', file)
    if (version) formData.append('version', version)

    const { token } = useAuth()
    const response = await appFetch(
      `/admin/policies/${encodeURIComponent(policyId)}/documents`,
      token.value ?? undefined,
      { method: 'POST', body: formData }
    )

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(message ?? `Upload failed: ${response.statusText}`)
    }

    return (await response.json()) as {
      id: string
      version: string
      originalFilename: string
      readingSummary: boolean
    }
  }

  async recordPolicyReview(
    input: Omit<RecordPolicyReviewInput, 'clientMutationId'>
  ): Promise<RecordPolicyReviewMutation['recordPolicyReview']['policy']> {
    const response = await this.request(print(RecordPolicyReviewGql), {
      input,
    })
    return (response.data as RecordPolicyReviewMutation).recordPolicyReview
      .policy
  }

  async assignTrainingModule(
    moduleId: string,
    employeeIds?: string[] | null,
    dueOn?: string | null
  ): Promise<number> {
    const response = await this.request(print(AssignTrainingModuleGql), {
      moduleId,
      employeeIds,
      dueOn,
    })
    return (response.data as AssignTrainingModuleMutation).assignTrainingModule
      .assignedCount
  }

  async requireTrainingRetake(
    moduleId: string,
    dueOn?: string | null
  ): Promise<number> {
    const response = await this.request(print(RequireTrainingRetakeGql), {
      moduleId,
      dueOn,
    })
    return (response.data as RequireTrainingRetakeMutation)
      .requireTrainingRetake.assignedCount
  }

  async updateTrainingAssignment(
    args: UpdateTrainingAssignmentMutationVariables
  ): Promise<
    UpdateTrainingAssignmentMutation['updateTrainingAssignment']['assignment']
  > {
    const response = await this.request(
      print(UpdateTrainingAssignmentGql),
      args
    )
    return (response.data as UpdateTrainingAssignmentMutation)
      .updateTrainingAssignment.assignment
  }

  async updateEmployeeTrainingFields(
    args: UpdateEmployeeTrainingFieldsMutationVariables
  ): Promise<number> {
    const response = await this.request(
      print(UpdateEmployeeTrainingFieldsGql),
      args
    )
    return (response.data as UpdateEmployeeTrainingFieldsMutation)
      .updateEmployeeTrainingFields.assignedCount
  }

  async recordPolicyAcknowledgement(
    employeeId: string,
    policyId: string
  ): Promise<void> {
    await this.request(print(RecordPolicyAcknowledgementGql), {
      employeeId,
      policyId,
    })
  }

  async getTrainingNudges(
    args: GetTrainingNudgesQueryVariables
  ): Promise<GetTrainingNudgesQuery['trainingNudges']> {
    const response = await this.request(print(GetTrainingNudgesGql), args)
    return (response.data as GetTrainingNudgesQuery).trainingNudges
  }

  async sendTrainingNudges(
    employeeIds: string[]
  ): Promise<SendTrainingNudgesMutation['sendTrainingNudges']['results']> {
    const response = await this.request(print(SendTrainingNudgesGql), {
      employeeIds,
    })
    return (response.data as SendTrainingNudgesMutation).sendTrainingNudges
      .results
  }

  // Pass an employee (creates or upgrades their login) or a user (upgrades them)
  async grantAdminPortalAccess(
    target: { employeeId: string } | { userId: string }
  ): Promise<void> {
    await this.request(print(GrantAdminPortalAccessGql), target)
  }

  // notify: false holds their email and calendar update to send later
  async updateAttendeeStatus(
    attendeeId: string,
    status: EventAttendeeStatusEnum,
    options: { reason?: string; notify?: boolean; wholeParty?: boolean } = {}
  ): Promise<void> {
    await this.request(print(UpdateAttendeeStatusGql), {
      attendeeId,
      status,
      ...options,
    } as UpdateAttendeeStatusInput)
  }

  async promoteFromWaitlist(
    registrationId: string
  ): Promise<{ id: string | undefined; warnings: string[] }> {
    const response = await this.request(print(PromoteFromWaitlistGql), {
      registrationId,
    })
    const data = response.data as PromoteFromWaitlistMutation
    return {
      id: data?.promoteFromWaitlist?.registration?.id,
      warnings: data?.promoteFromWaitlist?.warnings ?? [],
    }
  }

  async resendConfirmation(attendeeId: string): Promise<void> {
    await this.request(print(ResendConfirmationGql), { attendeeId })
  }

  async sendHeldUpdates(attendeeId: string): Promise<void> {
    await this.request(print(SendHeldUpdatesGql), { attendeeId })
  }

  async discardHeldUpdates(attendeeId: string): Promise<void> {
    await this.request(print(DiscardHeldUpdatesGql), { attendeeId })
  }

  // notify: false holds the plus-one's confirmation to send later
  async addPlusOne(
    attendeeId: string,
    plusOne: AttendeeDetailsInput,
    notify: boolean
  ): Promise<void> {
    await this.request(print(AddPlusOneGql), { attendeeId, plusOne, notify })
  }

  async registerAttendees(variables: {
    eventId: string
    lead: AttendeeDetailsInput
    plusOnes?: AttendeeDetailsInput[]
    target?: RegistrationTargetEnum
    notify?: boolean
  }): Promise<{ state: string }> {
    const response = await this.request(print(RegisterAttendeesGql), variables)
    const data = response.data as RegisterAttendeesMutation
    return { state: data.registerAttendees.state }
  }

  async getEventCheckIn(
    id: string
  ): Promise<NonNullable<GetEventCheckInQuery['event']>> {
    const response = await this.request(print(GetEventCheckInGql), { id })
    const data = response.data as GetEventCheckInQuery
    return data.event!
  }

  async checkInAttendee(
    attendeeId: string
  ): Promise<CheckInAttendeeMutation['checkInAttendee']> {
    const response = await this.request(print(CheckInAttendeeGql), {
      attendeeId,
    })
    return (response.data as CheckInAttendeeMutation).checkInAttendee
  }

  async undoCheckIn(
    attendeeId: string
  ): Promise<UndoCheckInMutation['undoCheckIn']> {
    const response = await this.request(print(UndoCheckInGql), { attendeeId })
    return (response.data as UndoCheckInMutation).undoCheckIn
  }

  async closeCheckIn(
    eventId: string
  ): Promise<CloseCheckInMutation['closeCheckIn']> {
    const response = await this.request(print(CloseCheckInGql), { eventId })
    return (response.data as CloseCheckInMutation).closeCheckIn
  }

  async getEventAttendee(
    id: string
  ): Promise<GetEventAttendeeQuery['eventAttendee']> {
    const response = await this.request(print(GetEventAttendeeGql), { id })
    return (response.data as GetEventAttendeeQuery).eventAttendee
  }

  async resolveContactDifferences(
    attendeeId: string,
    fields: {
      updateSalesforce?: EventContactFieldEnum[]
      useSalesforce?: EventContactFieldEnum[]
      dismiss?: EventContactFieldEnum[]
    }
  ): Promise<void> {
    await this.request(print(ResolveContactDifferencesGql), {
      attendeeId,
      ...fields,
    })
  }

  // notify: true also emails the guest their updated RSVP
  async updateAttendeeDetails(
    attendeeId: string,
    changes: AttendeeDetailsChangesInput,
    notify = false
  ): Promise<void> {
    await this.request(print(UpdateAttendeeDetailsGql), {
      attendeeId,
      changes,
      notify,
    })
  }

  async inviteGuests(
    eventId: string,
    emails: string
  ): Promise<InviteGuestsMutation['inviteGuests']['result']> {
    const response = await this.request(print(InviteGuestsGql), {
      eventId,
      emails,
    })
    return (response.data as InviteGuestsMutation).inviteGuests.result
  }

  async setEarlyAccess(
    eventId: string,
    attendeeIds: string[],
    enabled: boolean
  ): Promise<number> {
    const response = await this.request(print(SetEarlyAccessGql), {
      eventId,
      attendeeIds,
      enabled,
    })
    return (response.data as SetEarlyAccessMutation).setEarlyAccess.updatedCount
  }

  async sendEventFollowUps(
    eventId: string,
    segment: EventFollowUpSegmentEnum
  ): Promise<number> {
    const response = await this.request(print(SendEventFollowUpsGql), {
      eventId,
      segment,
    })
    return (response.data as SendEventFollowUpsMutation).sendEventFollowUps
      .queuedCount
  }

  async sendEventReminder(
    eventId: string,
    kind: EventReminderKindEnum
  ): Promise<number> {
    const response = await this.request(print(SendEventReminderGql), {
      eventId,
      kind,
    })
    return (response.data as SendEventReminderMutation).sendEventReminder
      .queuedCount
  }

  async sendTestEventEmail(
    eventId: string,
    emailKind: string
  ): Promise<string> {
    const response = await this.request(print(SendTestEventEmailGql), {
      eventId,
      emailKind,
    })
    const data = response.data as SendTestEventEmailMutation
    return data.sendTestEventEmail.deliveredTo
  }

  async getCampaigns(
    variables: GetCampaignsQueryVariables
  ): Promise<GetCampaignsQuery['campaigns']> {
    const response = await this.request(print(GetCampaignsGql), variables)
    return (response.data as GetCampaignsQuery).campaigns
  }

  async createEventCampaign(eventId: string): Promise<string> {
    const response = await this.request(print(CreateEventCampaignGql), {
      eventId,
    })
    const data = response.data as CreateEventCampaignMutation
    const campaignId = data.createEventCampaign.event?.campaign?.id
    if (!campaignId) {
      throw new Error('Failed to create campaign: no campaign ID returned')
    }
    return campaignId
  }

  async getEventWebsitePageStatus(
    slug: string
  ): Promise<EventWebsitePageStatusEnum> {
    const response = await this.request(print(GetEventWebsitePageStatusGql), {
      slug,
    })
    return (response.data as GetEventWebsitePageStatusQuery)
      .eventWebsitePageStatus
  }

  async getEventQuestionTemplates(): Promise<EventQuestionTemplate[]> {
    const response = await this.request(print(GetEventQuestionTemplatesGql))
    const data = response.data as GetEventQuestionTemplatesQuery
    return data.eventQuestionTemplates
  }

  async upsertEventQuestionTemplate(
    variables: UpsertEventQuestionTemplateMutationVariables
  ): Promise<EventQuestionTemplate> {
    const response = await this.request(
      print(UpsertEventQuestionTemplateGql),
      variables
    )
    const data = response.data as UpsertEventQuestionTemplateMutation
    return data.upsertEventQuestionTemplate.questionTemplate
  }

  async getEventSettings(): Promise<GetEventSettingsQuery['eventSettings']> {
    const response = await this.request(print(GetEventSettingsGql))
    return (response.data as GetEventSettingsQuery).eventSettings
  }

  async updateEventSettings(
    variables: UpdateEventSettingsMutationVariables
  ): Promise<UpdateEventSettingsMutation['updateEventSettings']> {
    const response = await this.request(
      print(UpdateEventSettingsGql),
      variables
    )
    return (response.data as UpdateEventSettingsMutation).updateEventSettings
  }

  async getCharityCategories(
    page: number,
    limit: number,
    search: string | undefined
  ): Promise<CharityCategoryAdminCollection> {
    const response = await this.request(print(GetCharityCategoriesGql), {
      page,
      limit,
      search,
    } as QueryAdminCharityCategoriesArgs)

    const data = response.data as GetCharityCategoriesQuery

    return <CharityCategoryAdminCollection>data.charityCategories
  }

  async getCharityCategory(id: string): Promise<CharityCategoryAdmin> {
    const response = await this.request(print(GetCharityCategoryGql), {
      id,
    } as QueryAdminCharityCategoryArgs)

    const data = response.data as GetCharityCategoryQuery

    return <CharityCategoryAdmin>data.charityCategory
  }

  async createCharityCategory(
    input: CharityCategoryChangeInput
  ): Promise<string | undefined> {
    const response = await this.request(print(CreateCharityCategoryGql), {
      charityCategoryInput: input,
    })
    const data = response.data as CreateCharityCategoryMutation
    return data.createCharityCategory.charityCategory?.id
  }

  async updateCharityCategory(
    charityCategoryId: string,
    input: CharityCategoryChangeInput
  ): Promise<void> {
    await this.request(print(UpdateCharityCategoryGql), {
      charityCategoryId,
      charityCategoryInput: input,
    } as UpdateCharityCategoryInput)
  }

  async deleteCharityCategory(id: string): Promise<void> {
    await this.request(print(DeleteCharityCategoryGql), { id })
  }

  async getPersonalisedHifoRecommendations(
    preferences: GivingPreferencesInput
  ): Promise<
    GetPersonalisedHifoRecommendationsQuery['personalisedHifoRecommendations']
  > {
    const response = await this.request(
      print(GetPersonalisedHifoRecommendationsGql),
      {
        preferences,
      } as GetPersonalisedHifoRecommendationsQueryVariables
    )

    const data = response.data as GetPersonalisedHifoRecommendationsQuery

    return data.personalisedHifoRecommendations
  }

  async getHifo(id: string): Promise<HifoAdmin> {
    const response = await this.request(print(GetHifoGql), {
      id,
    } as GetHifoQueryVariables)

    const data = response.data as GetHifoQuery

    return <HifoAdmin>data.hifo
  }

  async getHifos(
    page: number,
    limit: number,
    statuses?: HifoStatus[] | null,
    search?: string,
    sortBy?: string,
    hifoTypes?: HifoTypeEnum[] | null
  ): Promise<HifoAdminCollection> {
    const response = await this.request(print(GetHifosGql), {
      page,
      limit,
      statuses,
      hifoTypes,
      search,
      sortBy,
    })
    const data = response.data as GetHifosQuery
    return <HifoAdminCollection>data.hifos
  }

  async createHifo(hifoInput: Partial<HifoChangeInput>): Promise<number> {
    const response = await this.request(print(CreateHifoGql), {
      hifoInput: hifoInput,
    })
    const data = response.data as CreateHifoMutation
    return data?.createHifo?.hifo?.id as unknown as number
  }

  async editHifo(
    id: string,
    hifoInput: Partial<HifoChangeInput>,
    comment?: string
  ): Promise<HifoAdmin> {
    const response = await this.request(print(EditHifoGql), {
      id,
      hifoInput,
      comment: comment ?? null,
    })
    const data = response.data as EditHifoMutation
    return data?.updateHifo?.hifo as HifoAdmin
  }

  async deleteHifo(id: string): Promise<void> {
    await this.request(print(DeleteHifoGql), { id })
  }

  async getHifoCascades(
    page: number,
    limit: number,
    status?: string
  ): Promise<HifoCascadeCollection> {
    const response = await this.request(print(GetHifoCascadesGql), {
      page,
      limit,
      status,
    })
    const data = response.data as GetHifoCascadesQuery
    return <HifoCascadeCollection>data.hifoCascades
  }

  async getHifoCascade(id: string): Promise<HifoCascade> {
    const response = await this.request(print(GetHifoCascadeGql), { id })
    const data = response.data as GetHifoCascadeQuery
    return <HifoCascade>data.hifoCascade
  }

  async createHifoCascade(
    hifoCascadeInput: Partial<HifoCascadeChangeInput>
  ): Promise<string> {
    const response = await this.request(print(CreateHifoCascadeGql), {
      hifoCascadeInput,
    })
    const data = response.data as CreateHifoCascadeMutation
    const id = data?.createHifoCascade?.hifoCascade?.id
    if (!id) {
      throw new Error('Failed to create cascade: No ID returned')
    }
    return id
  }

  async updateHifoCascade(
    id: string,
    hifoCascadeInput: Partial<HifoCascadeChangeInput>
  ): Promise<HifoCascade | null> {
    const response = await this.request(print(UpdateHifoCascadeGql), {
      id,
      hifoCascadeInput,
    })
    const data = response.data as UpdateHifoCascadeMutation
    return (data?.updateHifoCascade?.hifoCascade as HifoCascade) ?? null
  }

  async createHifoCascadePitch(
    hifoCascadeId: string,
    hifoCascadePitchInput: Partial<HifoCascadePitchChangeInput>
  ): Promise<string> {
    const response = await this.request(print(CreateHifoCascadePitchGql), {
      hifoCascadeId,
      hifoCascadePitchInput,
    })
    const data = response.data as CreateHifoCascadePitchMutation
    const id = data?.createHifoCascadePitch?.hifoCascadePitch?.id
    if (!id) {
      throw new Error('Failed to create pitch: No ID returned')
    }
    return id
  }

  async deleteHifoCascadePitch(id: string): Promise<void> {
    const response = await this.request(print(DeleteHifoCascadePitchGql), {
      id,
    })
    const data = response.data as DeleteHifoCascadePitchMutation
    if (!data?.deleteHifoCascadePitch?.success) {
      throw new Error('Failed to delete pitch')
    }
  }

  async reorderHifoCascadePitches(
    hifoCascadeId: string,
    pitchOrdering: Array<{ pitchId: string; trancheNumber: number }>
  ): Promise<void> {
    const response = await this.request(print(ReorderHifoCascadePitchesGql), {
      hifoCascadeId,
      pitchOrdering,
    })
    const data = response.data as {
      reorderHifoCascade?: {
        hifoCascade?: { id: string } | null
      } | null
    }
    if (!data?.reorderHifoCascade?.hifoCascade?.id) {
      throw new Error('Failed to reorder pitches')
    }
  }

  async updateHifoCascadePitch(
    id: string,
    hifoCascadePitchInput: Partial<HifoCascadePitchChangeInput>
  ): Promise<void> {
    const response = await this.request(print(UpdateHifoCascadePitchGql), {
      id,
      hifoCascadePitchInput,
    })
    const data = response.data as UpdateHifoCascadePitchMutation
    if (!data?.updateHifoCascadePitch?.hifoCascadePitch?.id) {
      throw new Error('Failed to update pitch')
    }
  }

  async createHifoCascadePitchNote(
    hifoCascadePitchId: string,
    content: string
  ): Promise<void> {
    await this.request(print(CreateHifoCascadePitchNoteGql), {
      hifoCascadePitchId,
      content,
    })
  }

  async deleteHifoCascadePitchNote(id: string): Promise<void> {
    await this.request(print(DeleteHifoCascadePitchNoteGql), { id })
  }

  async createHifoCascadePitchMaterial(
    hifoCascadePitchId: string,
    name: string | undefined,
    url: string | undefined
  ): Promise<void> {
    await this.request(print(CreateHifoCascadePitchMaterialGql), {
      hifoCascadePitchId,
      name,
      url,
    })
  }

  async deleteHifoCascadePitchMaterial(id: string): Promise<void> {
    await this.request(print(DeleteHifoCascadePitchMaterialGql), { id })
  }

  async deleteHifoCascade(id: string): Promise<void> {
    const response = await this.request(print(DeleteHifoCascadeGql), { id })
    const data = response.data as DeleteHifoCascadeMutation
    if (!data?.deleteHifoCascade?.success) {
      throw new Error('Failed to delete cascade')
    }
  }

  async createImpactRecord(
    impactRecordInput: ImpactRecordInput
  ): Promise<string> {
    const response = await this.request(print(CreateImpactRecordGql), {
      impactRecordInput,
    })
    const data = response.data as CreateImpactRecordMutation
    return data?.createImpactRecord?.impactRecord?.id as string
  }

  async updateImpactRecord(
    impactRecordId: string,
    impactRecordInput: ImpactRecordInput
  ): Promise<void> {
    await this.request(print(UpdateImpactRecordGql), {
      impactRecordId,
      impactRecordInput,
    } as UpdateImpactRecordInput)
  }

  uploadHifoImage(hifoId: string, hifoFile: File): Promise<string> {
    return this.uploadHifoFile(hifoId, hifoFile, `/hifo/files`)
  }

  uploadHifoIcon(hifoId: string, hifoFile: File): Promise<string> {
    return this.uploadHifoFile(hifoId, hifoFile, `/hifo/icon`)
  }

  private async uploadHifoFile(
    hifoId: string,
    hifoFile: File,
    path: string
  ): Promise<string> {
    const formData = new FormData()
    formData.append('hifo_id', hifoId.toString())
    formData.append('hifo_file', hifoFile)

    return this.uploadMultipartImage(formData, path)
  }

  private async uploadMultipartImage(
    formData: FormData,
    path: string
  ): Promise<string> {
    const { token } = useAuth()

    const response = await appFetch(path, token.value ?? undefined, {
      method: 'POST',
      body: formData,
    })

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(
        message ?? `Failed to execute query: ${response.statusText}`
      )
    }
    const data = await response.json()
    if (data.errors) {
      throw new Error(
        data.errors.map((m: { message: string }) => m.message).join(', ')
      )
    }
    return data.imageUrl
  }

  async getImpactMeasurementCategories(): Promise<ImpactMeasurementCategory[]> {
    const response = await this.request(
      print(GetImpactMeasurementCategoriesGql)
    )

    const data = response.data as GetImpactMeasurementCategoriesQuery

    return <ImpactMeasurementCategory[]>data.impactMeasurementCategories
  }

  async getImpactMeasurementCategory(
    id: string
  ): Promise<ImpactMeasurementCategory> {
    const response = await this.request(
      print(GetImpactMeasurementCategoryGql),
      {
        id,
      } as QueryAdminImpactMeasurementCategoryArgs
    )

    const data = response.data as GetImpactMeasurementCategoryQuery

    return <ImpactMeasurementCategory>data.impactMeasurementCategory
  }

  async createImpactMeasurementCategory(
    input: ImpactMeasurementCategoryInput
  ): Promise<string> {
    const response = await this.request(
      print(CreateImpactMeasurementCategoryGql),
      {
        impactMeasurementCategoryInput: input,
      }
    )
    const data = response.data as CreateImpactMeasurementCategoryMutation
    return data.createImpactMeasurementCategory.impactMeasurementCategory
      ?.id as string
  }

  async updateImpactMeasurementCategory(
    impactMeasurementCategoryId: string,
    input: ImpactMeasurementCategoryInput
  ): Promise<void> {
    await this.request(print(UpdateImpactMeasurementCategoryGql), {
      impactMeasurementCategoryId,
      impactMeasurementCategoryInput: input,
    } as UpdateImpactMeasurementCategoryInput)
  }

  async deleteImpactMeasurementCategory(id: string): Promise<void> {
    await this.request(print(DeleteImpactMeasurementCategoryGql), { id })
  }

  async createImpactMeasurementItem(
    input: ImpactMeasurementItemInput
  ): Promise<string> {
    const response = await this.request(print(CreateImpactMeasurementItemGql), {
      impactMeasurementItemInput: input,
    })
    const data = response.data as CreateImpactMeasurementItemMutation
    return data.createImpactMeasurementItem.impactMeasurementItem?.id as string
  }

  async updateImpactMeasurementItem(
    impactMeasurementItemId: string,
    input: ImpactMeasurementItemInput
  ): Promise<void> {
    await this.request(print(UpdateImpactMeasurementItemGql), {
      impactMeasurementItemId,
      impactMeasurementItemInput: input,
    } as UpdateImpactMeasurementItemInput)
  }

  async deleteImpactMeasurementItem(id: string): Promise<void> {
    await this.request(print(DeleteImpactMeasurementItemGql), { id })
  }

  async getTargetAudiences(): Promise<TargetAudience[]> {
    const response = await this.request(print(GetTargetAudiencesGql))

    const data = response.data as GetTargetAudiencesQuery

    return <TargetAudience[]>data.targetAudiences
  }

  async getTargetAudience(id: string): Promise<TargetAudience> {
    const response = await this.request(print(GetTargetAudienceGql), {
      id,
    } as QueryAdminTargetAudienceArgs)

    const data = response.data as GetTargetAudienceQuery

    return <TargetAudience>data.targetAudience
  }

  async createTargetAudience(input: TargetAudienceInput): Promise<string> {
    const response = await this.request(print(CreateTargetAudienceGql), {
      targetAudienceInput: input,
    } as CreateTargetAudienceInput)
    const data = response.data as CreateTargetAudienceMutation
    return data.createTargetAudience.targetAudience?.id as string
  }

  async updateTargetAudience(
    targetAudienceId: string,
    input: TargetAudienceInput
  ): Promise<void> {
    await this.request(print(UpdateTargetAudienceGql), {
      targetAudienceId,
      targetAudienceInput: input,
    } as UpdateTargetAudienceInput)
  }

  async deleteTargetAudience(id: string): Promise<void> {
    await this.request(print(DeleteTargetAudienceGql), { id })
  }

  async getMatchCampaigns(): Promise<MatchCampaignAdmin[]> {
    const response = await this.request(print(GetMatchCampaignsGql))

    const data = response.data as GetMatchCampaignsQuery

    return <MatchCampaignAdmin[]>data.matchCampaigns
  }

  async getMatchCampaign(id: string): Promise<MatchCampaignAdmin> {
    const response = await this.request(print(GetMatchCampaignGql), {
      id,
    } as QueryAdminMatchCampaignArgs)

    const data = response.data as GetMatchCampaignQuery

    return <MatchCampaignAdmin>data.matchCampaign
  }

  async createMatchCampaign(input: MatchCampaignInput): Promise<string> {
    const response = await this.request(print(CreateMatchCampaignGql), {
      matchCampaignInput: input,
    } as CreateMatchCampaignInput)
    const data = response.data as CreateMatchCampaignMutation
    return data.createMatchCampaign.matchCampaign?.id as string
  }

  async updateMatchCampaign(input: MatchCampaignInput): Promise<void> {
    await this.request(print(UpdateMatchCampaignGql), {
      matchCampaignInput: input,
    } as UpdateMatchCampaignInput)
  }

  async deleteMatchCampaign(id: string): Promise<void> {
    await this.request(print(DeleteMatchCampaignGql), { id })
  }

  async getMatchCampaignCategories(): Promise<MatchCampaignCategory[]> {
    const response = await this.request(print(GetMatchCampaignCategoriesGql))

    const data = response.data as GetMatchCampaignCategoriesQuery

    return <MatchCampaignCategory[]>data.matchCampaignCategories
  }

  async getMatchCampaignCategory(id: string): Promise<MatchCampaignCategory> {
    const response = await this.request(print(GetMatchCampaignCategoryGql), {
      id,
    } as QueryAdminMatchCampaignCategoryArgs)

    const data = response.data as GetMatchCampaignCategoryQuery

    return <MatchCampaignCategory>data.matchCampaignCategory
  }

  async createMatchCampaignCategory(
    input: MatchCampaignCategoryInput
  ): Promise<string> {
    const response = await this.request(print(CreateMatchCampaignCategoryGql), {
      matchCampaignCategoryInput: input,
    } as CreateMatchCampaignCategoryInput)
    const data = response.data as CreateMatchCampaignCategoryMutation
    return data.createMatchCampaignCategory.matchCampaignCategory?.id as string
  }

  async updateMatchCampaignCategory(
    input: MatchCampaignCategoryInput
  ): Promise<void> {
    await this.request(print(UpdateMatchCampaignCategoryGql), {
      matchCampaignCategoryInput: input,
    } as UpdateMatchCampaignCategoryInput)
  }

  async deleteMatchCampaignCategory(id: string): Promise<void> {
    await this.request(print(DeleteMatchCampaignCategoryGql), { id })
  }

  async getCaseProcessingRecords(
    dateFrom: Date | undefined,
    dateTo: Date | undefined
  ): Promise<CaseProcessingRecord[]> {
    const response = await this.request(print(GetCaseProcessingRecordsGql), {
      dateFrom,
      dateTo,
    } as QueryAdminCaseProcessingRecordsArgs)

    const data = response.data as GetCaseProcessingRecordsQuery
    return <CaseProcessingRecord[]>data.caseProcessingRecords
  }

  async getDafStatementPeriods(): Promise<DafStatementPeriod[]> {
    const response = await this.request(print(GetDafStatementPeriodsGql))

    const data = response.data as GetDafStatementPeriodsQuery
    return <DafStatementPeriod[]>data.dafStatementPeriods
  }

  async getDafStatements(
    startDate: Date | undefined,
    endDate: Date | undefined
  ): Promise<DafStatement[]> {
    const response = await this.request(print(GetDafStatementsGql), {
      startDate,
      endDate,
    } as QueryAdminDafStatementsArgs)

    const data = response.data as GetDafStatementsQuery
    return <DafStatement[]>data.dafStatements
  }

  async generateAllDafStatements(input: DafStatementInput): Promise<boolean> {
    const response = await this.request(print(GenerateAllDafStatementsGql), {
      dafStatementInput: input,
    } as GenerateAllDafStatementsInput)
    const data = response.data as GenerateAllDafStatementsMutation
    return data.generateAllDafStatements.success ?? false
  }

  async publishDafStatements(ids: string[]): Promise<boolean> {
    const response = await this.request(print(PublishDafStatementsGql), {
      ids,
    } as PublishDafStatementsInput)
    const data = response.data as PublishDafStatementsMutation
    return data.publishDafStatements.success ?? false
  }

  async regenerateDafStatements(ids: string[]): Promise<boolean> {
    const response = await this.request(print(RegenerateDafStatementsGql), {
      ids,
    } as RegenerateDafStatementsInput)
    const data = response.data as RegenerateDafStatementsMutation
    return data.regenerateDafStatements.success ?? false
  }

  async getSageGiftAccounts(): Promise<SageGiftAccount[]> {
    const response = await this.request(print(GetSageGiftAccountsGql))
    return response.data.sageGiftAccounts as SageGiftAccount[]
  }

  async getSageGiftAccountRecords(
    page: number,
    limit: number,
    filters?: SageGiftAccountFilterConditionInput[] | undefined,
    sortBy?: string | undefined
  ): Promise<SageGiftAccountCollection> {
    const response = await this.request(print(GetSageGiftAccountRecordsGql), {
      page,
      limit,
      filters,
      sortBy,
    } as QueryAdminSageGiftAccountRecordsArgs)

    const data = response.data as GetSageGiftAccountRecordsQuery

    return <SageGiftAccountCollection>data.sageGiftAccountRecords
  }

  async getSageGiftAccount(id: string): Promise<SageGiftAccount> {
    const response = await this.request(print(GetSageGiftAccountGql), {
      id,
    } as QueryAdminSageGiftAccountArgs)

    const data = response.data as GetSageGiftAccountQuery

    return <SageGiftAccount>data.sageGiftAccount
  }

  async getSageJournalEntry(id: string): Promise<SageJournalEntry> {
    const response = await this.request(print(GetSageJournalEntryGql), {
      id,
    } as QueryAdminSageJournalEntryArgs)

    const data = response.data as GetSageJournalEntryQuery

    return <SageJournalEntry>data.sageJournalEntry
  }

  async getPotentialMatches(
    sageJournalEntryId: string,
    limitByLegalEntity: boolean,
    limitBySageGiftAccount: boolean,
    limitByValue: boolean,
    amountRange: number,
    currencyMustMatch: boolean,
    limitByDescription: boolean,
    limitByDate: boolean,
    dateRange: number,
    includeCasesAlreadyMatched: boolean
  ): Promise<PotentialMatch[]> {
    const response = await this.request(print(GetPotentialMatchesGql), {
      sageJournalEntryId,
      limitByLegalEntity,
      limitBySageGiftAccount,
      limitByValue,
      amountRange,
      currencyMustMatch,
      limitByDescription,
      limitByDate,
      dateRange,
      includeCasesAlreadyMatched,
    } as QueryAdminPotentialMatchesArgs)
    return response.data.potentialMatches as PotentialMatch[]
  }

  async getSageJournalEntries(
    page: number,
    limit: number,
    filters?: SageJournalEntryFilterConditionInput[] | undefined,
    sortBy?: string | undefined
  ): Promise<SageJournalEntryCollection> {
    const response = await this.request(print(GetSageJournalEntriesGql), {
      page,
      limit,
      filters,
      sortBy,
    } as QueryAdminSageJournalEntriesArgs)

    const data = response.data as GetSageJournalEntriesQuery

    return <SageJournalEntryCollection>data.sageJournalEntries
  }

  async getSageSalesforceMetric(
    metricType: SageSalesforceMetricTypeEnum,
    id?: string | undefined,
    forMonth?: Date | undefined
  ): Promise<SageSalesforceMetric> {
    const response = await this.request(print(GetSageSalesforceMetricGql), {
      metricType,
      id,
      forMonth,
    } as QueryAdminSageSalesforceMetricArgs)
    return response.data.sageSalesforceMetric as SageSalesforceMetric
  }

  async linkSageTransactionRecord(
    sageJournalEntryId: string,
    caseRecordId: string
  ): Promise<boolean> {
    const response = await this.request(print(LinkSageTransactionRecordGql), {
      sageJournalEntryId,
      caseRecordId,
    } as LinkSageTransactionRecordMutationVariables)
    return response.data.linkSageTransactionRecord.success
  }

  async updateSageGiftAccountRecord(
    sageGiftAccountId: string,
    fundAccountId: string,
    syncSageJournalEntries: boolean
  ): Promise<boolean> {
    const response = await this.request(print(UpdateSageGiftAccountRecordGql), {
      sageGiftAccountId,
      fundAccountId,
      syncSageJournalEntries,
    } as UpdateSageGiftAccountRecordMutationVariables)
    return response.data.updateSageGiftAccountRecord.success
  }

  async getGiftAccountBalances(
    dateFrom?: Date | undefined,
    dateTo?: Date | undefined
  ): Promise<GiftAccountBalance[]> {
    const response = await this.request(print(GetGiftAccountBalancesGql), {
      dateFrom,
      dateTo,
    } as QueryAdminGiftAccountBalancesArgs)
    return response.data.giftAccountBalances as GiftAccountBalance[]
  }

  async runBalanceReconciliation(
    args: QueryAdminBalanceReconciliationArgs
  ): Promise<BalanceReconciliationResult> {
    const response = await this.request(
      print(RunBalanceReconciliationGql),
      args
    )
    return response.data.balanceReconciliation as BalanceReconciliationResult
  }

  async getBalanceReconciliationTransactions(
    args: QueryAdminBalanceReconciliationTransactionsArgs
  ): Promise<BalanceReconciliationTransactions> {
    const response = await this.request(
      print(GetBalanceReconciliationTransactionsGql),
      args
    )
    return response.data
      .balanceReconciliationTransactions as BalanceReconciliationTransactions
  }

  async getSageGiftAccountDifferences(
    args: QueryAdminSageGiftAccountDifferencesArgs
  ): Promise<SageGiftAccountDifferenceCollection> {
    const response = await this.request(
      print(GetSageGiftAccountDifferencesGql),
      args
    )
    return response.data
      .sageGiftAccountDifferences as SageGiftAccountDifferenceCollection
  }

  async getSageGiftAccountDifferenceCounts(): Promise<SageGiftAccountDifferenceCounts> {
    const response = await this.request(
      print(GetSageGiftAccountDifferenceCountsGql)
    )
    return response.data
      .sageGiftAccountDifferenceCounts as SageGiftAccountDifferenceCounts
  }

  async acceptSageGiftAccountDifferences(
    ids: string[]
  ): Promise<SageGiftAccountDifferenceActionResult[]> {
    const response = await this.request(
      print(AcceptSageGiftAccountDifferencesGql),
      { ids }
    )
    return response.data.acceptSageGiftAccountDifferences
      .results as SageGiftAccountDifferenceActionResult[]
  }

  async ignoreSageGiftAccountDifferences(
    ids: string[],
    note?: string
  ): Promise<SageGiftAccountDifferenceActionResult[]> {
    const response = await this.request(
      print(IgnoreSageGiftAccountDifferencesGql),
      { ids, note }
    )
    return response.data.ignoreSageGiftAccountDifferences
      .results as SageGiftAccountDifferenceActionResult[]
  }

  async reopenSageGiftAccountDifferences(
    ids: string[]
  ): Promise<SageGiftAccountDifferenceActionResult[]> {
    const response = await this.request(
      print(ReopenSageGiftAccountDifferencesGql),
      { ids }
    )
    return response.data.reopenSageGiftAccountDifferences
      .results as SageGiftAccountDifferenceActionResult[]
  }

  async syncSageRecords(
    syncSageAccounts: boolean,
    syncSageTransactions: boolean,
    matchTransactionRecords: boolean
  ): Promise<boolean> {
    const response = await this.request(print(SyncSageRecordsGql), {
      syncSageAccounts,
      syncSageTransactions,
      matchTransactionRecords,
    } as SyncSageRecordsMutationVariables)
    return response.data.syncSageRecords.success
  }

  async getInvestmentDailyBalances(
    investmentPeriodId: string,
    legalEntityName: string,
    currencyFilter?: string | undefined
  ): Promise<InvestmentDailyBalance[]> {
    const response = await this.request(print(GetInvestmentDailyBalancesGql), {
      investmentPeriodId,
      legalEntityName,
      currencyFilter,
    } as QueryAdminInvestmentDailyBalancesArgs)
    return response.data.investmentDailyBalances as InvestmentDailyBalance[]
  }

  async getInvestmentPools(): Promise<InvestmentPool[]> {
    const response = await this.request(print(GetInvestmentPoolsGql))
    return response.data.investmentPools as InvestmentPool[]
  }

  async getInvestmentPeriods(): Promise<InvestmentPeriod[]> {
    const response = await this.request(print(GetInvestmentPeriodsGql))
    return response.data.investmentPeriods as InvestmentPeriod[]
  }

  async getInvestmentPoolPerformances(): Promise<InvestmentPoolPerformance[]> {
    const response = await this.request(print(GetInvestmentPoolPerformancesGql))
    return response.data
      .investmentPoolPerformances as InvestmentPoolPerformance[]
  }

  async getInvestmentAccountPerformances(): Promise<
    InvestmentAccountPerformance[]
  > {
    const response = await this.request(
      print(GetInvestmentAccountPerformancesGql)
    )
    return response.data
      .investmentAccountPerformances as InvestmentAccountPerformance[]
  }

  async createInvestmentPool(
    investmentPoolInput: InvestmentPoolInput
  ): Promise<InvestmentPool> {
    const response = await this.request(print(CreateInvestmentPoolGql), {
      investmentPoolInput,
    } as CreateInvestmentPoolMutationVariables)
    return response.data.createInvestmentPool.investmentPool
  }

  async updateInvestmentPool(
    investmentPoolInput: InvestmentPoolInput
  ): Promise<InvestmentPool> {
    const response = await this.request(print(UpdateInvestmentPoolGql), {
      investmentPoolInput,
    } as UpdateInvestmentPoolMutationVariables)
    return response.data.updateInvestmentPool.investmentPool
  }

  async lockInvestmentPeriod(id: string): Promise<InvestmentPeriod> {
    const response = await this.request(print(LockInvestmentPeriodGql), {
      id,
    } as LockInvestmentPeriodMutationVariables)
    return response.data.lockInvestmentPeriod.investmentPeriod
  }

  async deleteInvestmentPool(id: string): Promise<boolean> {
    const response = await this.request(print(DeleteInvestmentPoolGql), {
      id,
    } as DeleteInvestmentPoolMutationVariables)
    return response.data.deleteInvestmentPool.success
  }

  async updateInvestmentPoolPerformance(
    investmentPoolPerformanceInput: InvestmentPoolPerformanceInput
  ): Promise<InvestmentPoolPerformance> {
    const response = await this.request(
      print(UpdateInvestmentPoolPerformanceGql),
      {
        investmentPoolPerformanceInput,
      } as UpdateInvestmentPoolPerformanceMutationVariables
    )
    return response.data.updateInvestmentPoolPerformance
      .investmentPoolPerformance
  }

  async generateSalesforceCasesForAccountPerformance(
    accountPerformanceId: string
  ): Promise<boolean> {
    const response = await this.request(
      print(GenerateSalesforceCasesForAccountPerformanceGql),
      {
        accountPerformanceId,
      } as GenerateSalesforceCasesForAccountPerformanceInput
    )
    return response.data.generateSalesforceCasesForAccountPerformance.success
  }

  async generateSalesforceCasesForPeriod(periodId: string): Promise<boolean> {
    const response = await this.request(
      print(GenerateSalesforceCasesForPeriodGql),
      {
        periodId,
      } as GenerateSalesforceCasesForPeriodInput
    )
    return response.data.generateSalesforceCasesForPeriod.success
  }

  async getEmployees(): Promise<Employee[]> {
    const response = await this.request(print(GetEmployeesGql))
    return response.data.employees as Employee[]
  }

  async addNewStarter(args: AddNewStarterMutationVariables): Promise<string> {
    const response = await this.request(print(AddNewStarterGql), args)
    return (response.data as AddNewStarterMutation).addNewStarter.employee.id
  }

  async updateEmployee(employeeInput: EmployeeChangeInput): Promise<void> {
    await this.request(print(UpdateEmployeeGql), {
      employeeInput,
    })
  }

  async setEmployeeLeaving(
    args: SetEmployeeLeavingMutationVariables
  ): Promise<SetEmployeeLeavingMutation['setEmployeeLeaving']['employee']> {
    const response = await this.request(print(SetEmployeeLeavingGql), args)
    return (response.data as SetEmployeeLeavingMutation).setEmployeeLeaving
      .employee
  }

  async getTeams(includeArchived = false): Promise<GetTeamsQuery['teams']> {
    const response = await this.request(print(GetTeamsGql), {
      includeArchived,
    })
    return (response.data as GetTeamsQuery).teams
  }

  async createTeam(name: string): Promise<TeamFieldsFragment> {
    const response = await this.request(print(CreateTeamGql), { name })
    return (response.data as CreateTeamMutation).createTeam.team
  }

  async updateTeam(
    args: UpdateTeamMutationVariables
  ): Promise<TeamFieldsFragment> {
    const response = await this.request(print(UpdateTeamGql), args)
    return (response.data as UpdateTeamMutation).updateTeam.team
  }

  async getFundGroups(
    page: number,
    limit: number,
    search: string | undefined,
    sortBy: string | undefined
  ): Promise<FundGroupCollection> {
    const response = await this.request(print(GetFundGroupsGql), {
      page,
      limit,
      search,
      sortBy,
    } as QueryAdminFundGroupsArgs)

    const data = response.data as GetFundGroupsQuery

    return <FundGroupCollection>data.fundGroups
  }

  async getFundGroup(id: string): Promise<FundGroup> {
    const response = await this.request(print(GetFundGroupGql), {
      id,
    } as QueryAdminFundGroupArgs)

    const data = response.data as GetFundGroupQuery

    return <FundGroup>data.fundGroup
  }

  async getFunds(
    page: number,
    limit: number,
    stringFilters?: StringFilterInput[] | undefined,
    numericFilters?: NumericFilterInput[] | undefined,
    dateFilters?: DateFilterInput[] | undefined,
    legalEntityFilters?: string[] | undefined,
    recordTypeFilters?: string[] | undefined,
    sortBy?: string | undefined
  ): Promise<FundCollection> {
    const response = await this.request(print(GetFundsGql), {
      page,
      limit,
      stringFilters,
      numericFilters,
      dateFilters,
      legalEntityFilters,
      recordTypeFilters,
      sortBy,
    } as QueryAdminFundsArgs)

    const data = response.data as GetFundsQuery

    return <FundCollection>data.funds
  }

  async getFundAccounts(
    page: number,
    limit: number,
    search: string | undefined,
    adminFeeIssueFilter?: boolean
  ): Promise<FundAccountCollection> {
    const response = await this.request(print(GetFundAccountsGql), {
      page,
      limit,
      search,
      adminFeeIssueFilter,
    } as QueryAdminFundAccountsArgs)

    const data = response.data as GetFundAccountsQuery

    return <FundAccountCollection>data.fundAccounts
  }

  async getFund(id: string): Promise<Fund> {
    const response = await this.request(print(GetFundGql), {
      id,
    } as QueryAdminFundArgs)

    const data = response.data as GetFundQuery

    return <Fund>data.fund
  }

  async getCharities(
    page: number,
    limit: number,
    stringFilters?: CharityStringFilterInput[] | undefined,
    sortBy?: string | undefined
  ): Promise<CharityCollection> {
    const response = await this.request(print(GetCharitiesGql), {
      page,
      limit,
      stringFilters,
      sortBy,
    } as QueryAdminCharitiesArgs)

    const data = response.data as GetCharitiesQuery

    return <CharityCollection>data.charities
  }

  async getCharity(id: string): Promise<Charity> {
    const response = await this.request(print(GetCharityGql), {
      id,
    } as QueryAdminCharityArgs)

    const data = response.data as GetCharityQuery

    return <Charity>data.charity
  }

  async getCharityChariotDisbursements(
    id: string
  ): Promise<ChariotDisbursement[]> {
    const response = await this.request(
      print(GetCharityChariotDisbursementsGql),
      {
        id,
      } as QueryAdminCharityArgs
    )

    const data = response.data as GetCharityChariotDisbursementsQuery

    return data.charity?.chariotDisbursements ?? []
  }

  async getHifoAutofill(
    name: string | undefined,
    charityId: string | undefined
  ): Promise<HifoAdmin | null> {
    const response = await this.request(print(GetHifoAutofillGql), {
      name,
      charityId,
    } as QueryAdminHifoAutofillArgs)

    return response.data.hifoAutofill
  }

  async getUsDueDiligence(id: string): Promise<UsDueDiligence> {
    const response = await this.request(print(GetUsDueDiligenceGql), {
      id,
    })

    const data = response.data as { usDueDiligence: UsDueDiligence | null }
    if (!data.usDueDiligence) {
      throw new GraphQlUnexpectedError(
        `US due diligence not found for ID: ${id}`
      )
    }

    return data.usDueDiligence
  }

  async updateUsDueDiligence(
    input: UpdateUsDueDiligenceInput
  ): Promise<
    UpdateUsDueDiligenceMutation['updateUsDueDiligence']['usDueDiligence']
  > {
    const response = await this.request(print(UpdateUsDueDiligenceGql), {
      input,
    })
    const data = response.data as UpdateUsDueDiligenceMutation
    return data.updateUsDueDiligence.usDueDiligence
  }

  async updateZeroHarmReview(input: UpdateZeroHarmReviewInput): Promise<void> {
    await this.request(print(UpdateZeroHarmReviewGql), {
      input,
    })
  }

  async uploadUsDueDiligenceAttachment(
    usDueDiligenceId: string,
    file: File
  ): Promise<{ id: string; fileName: string; usDueDiligenceId: number }> {
    const formData = new FormData()
    formData.append('us_due_diligence_id', usDueDiligenceId)
    formData.append('file', file)

    const { token } = useAuth()

    const response = await appFetch(
      '/admin/us-due-diligence-attachments',
      token.value ?? undefined,
      {
        method: 'POST',
        body: formData,
      }
    )

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(message ?? `Upload failed: ${response.statusText}`)
    }

    const data = (await response.json()) as {
      id: string
      fileName: string
      usDueDiligenceId: number
    }
    if (!data?.id) {
      throw new Error('Upload failed: unexpected response')
    }
    return data
  }

  async deleteUsDueDiligenceAttachment(attachmentId: string): Promise<void> {
    const { token } = useAuth()

    const response = await appFetch(
      `/admin/us-due-diligence-attachments/${encodeURIComponent(attachmentId)}`,
      token.value ?? undefined,
      {
        method: 'DELETE',
      }
    )

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(message ?? `Delete failed: ${response.statusText}`)
    }
  }

  async uploadCaseRecordAttachment(
    caseRecordId: string,
    file: File
  ): Promise<{ id: string; fileName: string; caseRecordId: number }> {
    const formData = new FormData()
    formData.append('case_record_id', caseRecordId)
    formData.append('file', file)

    const { token } = useAuth()

    const response = await appFetch(
      '/admin/case-record-attachments',
      token.value ?? undefined,
      {
        method: 'POST',
        body: formData,
      }
    )

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(message ?? `Upload failed: ${response.statusText}`)
    }

    const data = (await response.json()) as {
      id: string
      fileName: string
      caseRecordId: number
    }
    if (!data?.id) {
      throw new Error('Upload failed: unexpected response')
    }
    return data
  }

  async uploadTrainingModuleMedia(
    moduleId: string,
    kind: TrainingMediaKind,
    file: File
  ): Promise<TrainingMediaResult> {
    const formData = new FormData()
    formData.append('file', file)
    return this.trainingMediaRequest(moduleId, kind, {
      method: 'POST',
      body: formData,
    })
  }

  async removeTrainingModuleMedia(
    moduleId: string,
    kind: TrainingMediaKind
  ): Promise<TrainingMediaResult> {
    return this.trainingMediaRequest(moduleId, kind, { method: 'DELETE' })
  }

  async uploadTrainingCoursePoster(
    courseId: string,
    file: File
  ): Promise<TrainingCourseMediaResult> {
    const formData = new FormData()
    formData.append('file', file)
    return this.trainingMediaRequest(
      courseId,
      'poster',
      { method: 'POST', body: formData },
      'training-courses'
    )
  }

  async removeTrainingCoursePoster(
    courseId: string
  ): Promise<TrainingCourseMediaResult> {
    return this.trainingMediaRequest(
      courseId,
      'poster',
      { method: 'DELETE' },
      'training-courses'
    )
  }

  private async trainingMediaRequest<Result = TrainingMediaResult>(
    id: string,
    kind: TrainingMediaKind,
    init: RequestInit,
    collection: 'training-modules' | 'training-courses' = 'training-modules'
  ): Promise<Result> {
    const { token } = useAuth()
    const response = await appFetch(
      `/admin/${collection}/${encodeURIComponent(id)}/media/${kind}`,
      token.value ?? undefined,
      init
    )

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(message ?? `Upload failed: ${response.statusText}`)
    }

    return (await response.json()) as Result
  }

  async deleteCaseRecordAttachment(attachmentId: string): Promise<void> {
    const { token } = useAuth()

    const response = await appFetch(
      `/admin/case-record-attachments/${encodeURIComponent(attachmentId)}`,
      token.value ?? undefined,
      {
        method: 'DELETE',
      }
    )

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(message ?? `Delete failed: ${response.statusText}`)
    }
  }

  private async tryParseJsonError(response: Response): Promise<string | null> {
    try {
      const body = (await response.json()) as { error?: string }
      return body.error ?? null
    } catch {
      return null
    }
  }

  async getFundRecordTypes(): Promise<FundRecord[]> {
    const response = await this.request(print(GetFundRecordTypesGql))
    return response.data.fundRecordTypes as FundRecord[]
  }

  async getLegalEntities(): Promise<LegalEntityAdmin[]> {
    const response = await this.request(print(GetLegalEntitiesGql))
    return response.data.legalEntities as LegalEntityAdmin[]
  }

  async getLegalEntityByName(name: string): Promise<LegalEntityAdmin> {
    const response = await this.request(print(GetLegalEntityByNameGql), {
      name,
    } as QueryAdminLegalEntityByNameArgs)

    const data = response.data as GetLegalEntityByNameQuery

    return <LegalEntityAdmin>data.legalEntityByName
  }

  async getAdminFeeSageJournalEntries(
    page: number,
    limit: number,
    search: string | undefined,
    filters: Pick<
      QueryAdminAdminFeeSageJournalEntriesArgs,
      'statuses' | 'journalEntryTypes'
    > = {}
  ): Promise<AdminFeeSageJournalEntryCollection> {
    const response = await this.request(
      print(GetAdminFeeSageJournalEntriesGql),
      {
        page,
        limit,
        search,
        ...filters,
      } as QueryAdminAdminFeeSageJournalEntriesArgs
    )

    const data = response.data as GetAdminFeeSageJournalEntriesQuery

    return <AdminFeeSageJournalEntryCollection>data.adminFeeSageJournalEntries
  }

  async getDafAdminFeePeriods(
    page: number,
    limit: number,
    search: string | undefined
  ): Promise<DafAdminFeePeriodCollection> {
    const response = await this.request(print(GetDafAdminFeePeriodsGql), {
      page,
      limit,
      search,
    } as QueryAdminDafAdminFeePeriodsArgs)

    const data = response.data as GetDafAdminFeePeriodsQuery

    return <DafAdminFeePeriodCollection>data.dafAdminFeePeriods
  }

  async getAdminFeeSageJournalEntry(
    id: string
  ): Promise<AdminFeeSageJournalEntry> {
    const response = await this.request(print(GetAdminFeeSageJournalEntryGql), {
      id,
    } as QueryAdminAdminFeeSageJournalEntryArgs)

    const data = response.data as GetAdminFeeSageJournalEntryQuery

    return <AdminFeeSageJournalEntry>data.adminFeeSageJournalEntry
  }

  async getDafAdminFeePeriod(id: string): Promise<DafAdminFeePeriod> {
    const response = await this.request(print(GetDafAdminFeePeriodGql), {
      id,
    } as QueryAdminDafAdminFeePeriodArgs)

    const data = response.data as GetDafAdminFeePeriodQuery

    return <DafAdminFeePeriod>data.dafAdminFeePeriod
  }

  async getDafAdminFeesForFund(fundId: string): Promise<FundAdminFee[]> {
    const response = await this.request(print(GetDafAdminFeesForFundGql), {
      fundId,
    } as QueryAdminDafAdminFeesForFundArgs)

    const data = response.data as GetDafAdminFeesForFundQuery

    return <FundAdminFee[]>data.dafAdminFeesForFund
  }

  async getFundAccountAverageMonthlyBalances(
    fundAccountId: string,
    page: number,
    limit: number
  ): Promise<FundAccountAverageMonthlyBalanceCollection> {
    const response = await this.request(
      print(GetFundAccountAverageMonthlyBalancesGql),
      {
        fundAccountId,
        page,
        limit,
      } as QueryAdminFundAccountAverageMonthlyBalancesArgs
    )

    const data = response.data as GetFundAccountAverageMonthlyBalancesQuery

    return <FundAccountAverageMonthlyBalanceCollection>(
      data.fundAccountAverageMonthlyBalances
    )
  }

  async lockDafAdminFeePeriod(id: string): Promise<boolean> {
    const response = await this.request(print(LockDafAdminFeePeriodGql), { id })
    return response.data.lockDafAdminFeePeriod.dafAdminFeePeriod
  }

  async completeAdminFeeSageJournalEntry(id: string): Promise<boolean> {
    const response = await this.request(
      print(CompleteAdminFeeSageJournalEntryGql),
      { id }
    )
    return response.data.completeAdminFeeSageJournalEntry.success
  }

  async recalculateDafAdminFees(): Promise<boolean> {
    const response = await this.request(print(RecalculateDafAdminFeesGql))
    return response.data.recalculateDafAdminFees.success
  }

  async getDafPlanChanges(
    page: number,
    limit: number,
    fundId?: string | number
  ): Promise<DafPlanChangeCollection> {
    const response = await this.request(print(GetDafPlanChangesGql), {
      fundId,
      page,
      limit,
    } as QueryAdminDafPlanChangesArgs)

    const data = response.data as GetDafPlanChangesQuery

    return <DafPlanChangeCollection>data.dafPlanChanges
  }

  async getDafInvestmentAllocationChanges(
    page: number,
    limit: number,
    fundId?: string | number
  ): Promise<DafInvestmentAllocationChangeCollection> {
    const response = await this.request(
      print(GetDafInvestmentAllocationChangesGql),
      {
        fundId,
        page,
        limit,
      } as QueryAdminDafInvestmentAllocationChangesArgs
    )

    const data = response.data as GetDafInvestmentAllocationChangesQuery

    return <DafInvestmentAllocationChangeCollection>(
      data.dafInvestmentAllocationChanges
    )
  }

  async getCompanies(
    page: number,
    limit: number,
    stringFilters?: CompanyStringFilterInput[] | undefined,
    sortBy?: string | undefined
  ): Promise<CompanyAdminCollection> {
    const response = await this.request(print(GetCompaniesGql), {
      page,
      limit,
      stringFilters,
      sortBy,
    } as QueryAdminCompaniesArgs)

    const data = response.data as GetCompaniesQuery

    return <CompanyAdminCollection>data.companies
  }

  async getCompany(id: string): Promise<CompanyAdmin> {
    const response = await this.request(print(GetCompanyGql), {
      id,
    } as QueryAdminCompanyArgs)

    const data = response.data as GetCompanyQuery

    return <CompanyAdmin>data.company
  }

  async getCompanyRecordTypes(): Promise<CompanyRecord[]> {
    const response = await this.request(print(GetCompanyRecordTypesGql))
    return response.data.companyRecordTypes as CompanyRecord[]
  }

  async getContacts(
    page: number,
    limit: number,
    stringFilters?: ContactStringFilterInput[] | undefined,
    sortBy?: string | undefined
  ): Promise<ContactCollection> {
    const response = await this.request(print(GetContactsGql), {
      page,
      limit,
      stringFilters,
      sortBy,
    } as QueryAdminContactsArgs)

    const data = response.data as GetContactsQuery

    return <ContactCollection>data.contacts
  }

  async getContact(id: string): Promise<Contact> {
    const response = await this.request(print(GetContactGql), {
      id,
    } as QueryAdminContactArgs)

    const data = response.data as GetContactQuery

    return <Contact>data.contact
  }

  async getContactRecordTypes(): Promise<ContactRecord[]> {
    const response = await this.request(print(GetContactRecordTypesGql))
    return response.data.contactRecordTypes as ContactRecord[]
  }

  async getSearchEmployees(
    page: number,
    limit: number,
    stringFilters?: EmployeeStringFilterInput[] | undefined,
    booleanFilters?: EmployeeBooleanFilterInput[] | undefined,
    sortBy?: string | undefined
  ): Promise<EmployeeCollection> {
    const response = await this.request(print(GetSearchEmployeesGql), {
      page,
      limit,
      stringFilters,
      booleanFilters,
      sortBy,
    } as QueryAdminSearchEmployeesArgs)

    const data = response.data as GetSearchEmployeesQuery

    return <EmployeeCollection>data.searchEmployees
  }

  // withUser needs VIEW_USER
  async getEmployee(id: string, { withUser = false } = {}): Promise<Employee> {
    const response = await this.request(print(GetEmployeeGql), {
      id,
      withUser,
    } as GetEmployeeQueryVariables)

    const data = response.data as GetEmployeeQuery
    return <Employee>data.employee
  }

  async getCaseTypes(): Promise<CaseType[]> {
    const response = await this.request(print(GetCaseTypesGql))
    return response.data.caseTypes as CaseType[]
  }

  async getPermissions(): Promise<Permission[]> {
    const response = await this.request(print(GetPermissionsGql))
    return response.data.permissions as Permission[]
  }

  async getRole(id: string): Promise<Role> {
    const response = await this.request(print(GetRoleGql), { id })
    return response.data.role
  }

  async getRoles(): Promise<Role[]> {
    const response = await this.request(print(GetRolesGql))
    return response.data.roles
  }

  async createRole(roleInput: Partial<RoleInput>): Promise<void> {
    await this.request(print(CreateRoleGql), { roleInput })
  }

  async editRole(roleInput: Partial<RoleInput>): Promise<Role> {
    const response = await this.request(print(EditRoleGql), { roleInput })
    return response.data?.updateRole?.role
  }

  async getCaseRecords(
    page: number,
    limit: number,
    filterGroup?: CaseRecordFilterGroupInput | undefined,
    balanceType?: string | undefined,
    fundAccountIds?: string[] | undefined,
    sortBy?: string | undefined,
    includeSageJournalEntries?: boolean | undefined
  ): Promise<CaseRecordCollection> {
    const response = await this.request(print(GetCaseRecordsGql), {
      page,
      limit,
      filterGroup,
      balanceType,
      fundAccountIds,
      sortBy,
      includeSageJournalEntries,
    } as QueryAdminCaseRecordsArgs)

    const data = response.data as GetCaseRecordsQuery

    return <CaseRecordCollection>data.caseRecords
  }

  async getGrants(
    page: number,
    limit: number,
    sortBy?: string | undefined,
    senderLegalEntityIds?: string[] | undefined,
    statuses?: GrantCaseRecordStatusEnum[] | undefined,
    filterGroup?: GrantFilterGroupInput | undefined
  ): Promise<CaseRecordCollection> {
    const response = await this.request(print(GetGrantsGql), {
      page,
      limit,
      sortBy,
      senderLegalEntityIds,
      statuses,
      filterGroup,
    } as QueryAdminGrantsArgs)

    const data = response.data as GetGrantsQuery

    return <CaseRecordCollection>data.grants
  }

  async getCaseRecord(args: QueryAdminCaseRecordArgs): Promise<CaseRecord> {
    const response = await this.request(print(GetCaseRecordGql), args)

    const data = response.data as GetCaseRecordQuery

    return <CaseRecord>data.caseRecord
  }

  async updateCaseRecord(input: UpdateCaseRecordInput): Promise<void> {
    await this.request(print(UpdateCaseRecordGql), {
      input,
    })
  }

  async updateGrantCaseRecord(
    input: UpdateGrantCaseRecordInput
  ): Promise<void> {
    await this.request(print(UpdateGrantCaseRecordGql), {
      input,
    })
  }

  async createUsDisbursement(caseRecordId: string): Promise<boolean> {
    const response = await this.request(print(CreateUsDisbursementGql), {
      caseRecordId,
    })
    const data = response.data as CreateUsDisbursementMutation
    return data.createUsDisbursement.success
  }

  async cancelGrant(caseRecordId: string, reason: string): Promise<void> {
    await this.request(print(CancelGrantGql), {
      caseRecordId,
      reason,
    })
  }

  async snoozeGrant(caseRecordId: string, snoozedUntil: string): Promise<void> {
    await this.request(print(SnoozeGrantGql), {
      caseRecordId,
      snoozedUntil,
    })
  }

  async unsnoozeGrant(caseRecordId: string): Promise<void> {
    await this.request(print(UnsnoozeGrantGql), {
      caseRecordId,
    })
  }

  async processCaseRecordGrantCompliance(
    caseRecordId: string
  ): Promise<boolean> {
    const response = await this.request(
      print(ProcessCaseRecordGrantComplianceGql),
      {
        caseRecordId,
      }
    )
    const data = response.data as ProcessCaseRecordGrantComplianceMutation
    return data.processCaseRecordGrantCompliance.success
  }

  async createCaseNote(caseRecordId: string, content: string): Promise<void> {
    await this.request(print(CreateCaseNoteGql), {
      caseRecordId,
      content,
    })
  }

  async updateCaseNote(id: string, content: string): Promise<void> {
    await this.request(print(UpdateCaseNoteGql), {
      id,
      content,
    })
  }

  async deleteCaseNote(id: string): Promise<void> {
    await this.request(print(DeleteCaseNoteGql), {
      id,
    })
  }

  async createUsDueDiligenceNote(
    usDueDiligenceId: string,
    content: string
  ): Promise<void> {
    await this.request(print(CreateUsDueDiligenceNoteGql), {
      usDueDiligenceId,
      content,
    })
  }

  async updateUsDueDiligenceNote(id: string, content: string): Promise<void> {
    await this.request(print(UpdateUsDueDiligenceNoteGql), {
      id,
      content,
    })
  }

  async deleteUsDueDiligenceNote(id: string): Promise<void> {
    await this.request(print(DeleteUsDueDiligenceNoteGql), {
      id,
    })
  }

  async updateGrantComplianceCheck(
    input: UpdateGrantComplianceCheckInput
  ): Promise<GrantComplianceCheck> {
    const response = await this.request(print(UpdateGrantComplianceCheckGql), {
      input,
    })
    const data = response.data as UpdateGrantComplianceCheckMutation
    return data.updateGrantComplianceCheck.grantComplianceCheck
  }

  async getAttachments(
    recordId: string,
    recordType: AttachmentRecordType
  ): Promise<SfAttachments[]> {
    const response = await this.request(print(GetAttachmentsInfoGql), {
      recordId,
      recordType,
    } as QueryAdminAttachmentsArgs)

    const data = response.data as GetAttachmentsInfoQuery

    return data.attachments || []
  }

  async getCaseRecordAccountingHistory(
    caseRecordId: string
  ): Promise<
    GetCaseRecordAccountingHistoryQuery['caseRecordAccountingHistory']
  > {
    const response = await this.request(
      print(GetCaseRecordAccountingHistoryGql),
      { caseRecordId } as QueryAdminCaseRecordAccountingHistoryArgs
    )

    const data = response.data as GetCaseRecordAccountingHistoryQuery

    return data.caseRecordAccountingHistory
  }

  async getRelatedCaseRecords(caseRecordId: string): Promise<RelatedCase[]> {
    const response = await this.request(print(GetRelatedCasesGql), {
      caseRecordId,
    } as QueryAdminRelatedCaseRecordsArgs)

    const data = response.data as GetRelatedCaseRecordsQuery

    return data.relatedCaseRecords as RelatedCase[]
  }

  async updateDafPlan(
    input: UpdateFundsDafPlanInput
  ): Promise<UpdateFundsDafPlanPayload> {
    const response = await this.request(print(UpdateFundsDafPlanGql), { input })
    return response.data as UpdateFundsDafPlanPayload
  }

  async updateDafInvestmentAllocation(
    input: UpdateFundsDafInvestmentAllocationInput
  ): Promise<UpdateFundsDafInvestmentAllocationPayload> {
    const response = await this.request(
      print(UpdateFundsDafInvestmentAllocationGql),
      { input }
    )
    return response.data as UpdateFundsDafInvestmentAllocationPayload
  }

  async getDataUploads(
    page: number,
    limit: number
  ): Promise<DataUploadCollection> {
    const response = await this.request(print(GetDataUploadsGql), {
      page,
      limit,
    } as QueryAdminDataUploadsArgs)

    const data = response.data as GetDataUploadsQuery

    return <DataUploadCollection>data.dataUploads
  }

  async getDataUpload(id: string): Promise<DataUpload> {
    const response = await this.request(print(GetDataUploadGql), {
      id,
    } as QueryAdminDataUploadArgs)

    const data = response.data as GetDataUploadQuery

    return <DataUpload>data.dataUpload
  }

  async getRequestsForFunding(
    page: number,
    limit: number,
    search?: string,
    formType?: RequestForFundingFormTypeEnum
  ): Promise<RequestForFundingCollection> {
    const response = await this.request(print(GetRequestsForFundingGql), {
      page,
      limit,
      search,
      formType,
    } as QueryAdminRequestsForFundingArgs)

    const data = response.data as GetRequestsForFundingQuery

    return <RequestForFundingCollection>data.requestsForFunding
  }

  async getRequestForFunding(id: string): Promise<RequestForFunding> {
    const response = await this.request(print(GetRequestForFundingGql), {
      id,
    } as QueryAdminRequestForFundingArgs)

    const data = response.data as GetRequestForFundingQuery

    return <RequestForFunding>data.requestForFunding
  }

  async getDataUploadRows(dataUploadId: string): Promise<DataUploadRow[]> {
    const response = await this.request(print(GetDataUploadRowsGql), {
      dataUploadId,
    } as QueryAdminDataUploadRowsArgs)

    const data = response.data as GetDataUploadRowsQuery

    return <DataUploadRow[]>data.dataUploadRows
  }

  async changeDataUploadRowDecision(
    id: string,
    decision: DataUploadRowDecision
  ): Promise<boolean> {
    const response = await this.request(print(ChangeDataUploadRowDecisionGql), {
      id,
      decision,
    } as ChangeDataUploadRowDecisionMutationVariables)
    return response.data.changeDataUploadRowDecision.success
  }

  async createDataUploadRowRecord(id: string): Promise<boolean> {
    const response = await this.request(print(CreateDataUploadRowRecordGql), {
      id,
    } as CreateDataUploadRowRecordMutationVariables)
    return response.data.createDataUploadRowRecord.success
  }

  async createAllDataUploadRowRecords(id: string): Promise<boolean> {
    const response = await this.request(
      print(CreateAllDataUploadRowRecordsGql),
      {
        id,
      } as CreateAllDataUploadRowRecordsMutationVariables
    )
    return response.data.createAllDataUploadRowRecords.success
  }

  async runDuplicateChecker(id: string): Promise<boolean> {
    const response = await this.request(print(RunDuplicateCheckerGql), {
      id,
    } as RunDuplicateCheckerMutationVariables)
    return response.data.runDuplicateChecker.success
  }

  async getExchangeRates(
    page: number,
    limit: number,
    currency?: string | undefined,
    source?: string | undefined,
    sortBy?: string | undefined
  ): Promise<ExchangeRateCollection> {
    const response = await this.request(print(GetExchangeRatesGql), {
      page,
      limit,
      currency,
      source,
      sortBy,
    } as QueryAdminExchangeRatesArgs)

    const data = response.data as GetExchangeRatesQuery

    return <ExchangeRateCollection>data.exchangeRates
  }

  async getDafAdvisorExternalOpexDonations(
    dateFrom: string,
    dateTo: string
  ): Promise<DafAdvisorExternalOpexDonation[]> {
    const response = await this.request(
      print(GetDafAdvisorExternalOpexDonationsGql),
      {
        dateFrom,
        dateTo,
      } as QueryAdminDafAdvisorExternalOpexDonationsArgs
    )

    const data = response.data as GetDafAdvisorExternalOpexDonationsQuery

    return data.dafAdvisorExternalOpexDonations as DafAdvisorExternalOpexDonation[]
  }

  async getCharityContacts(charityId: string): Promise<AdminCharityContact[]> {
    const response = await this.request(print(GetCharityContactsGql), {
      charityId,
    } as QueryAdminCharityContactsArgs)

    const data = response.data as GetCharityContactsQuery

    return <AdminCharityContact[]>data.charityContacts
  }

  async getCharityContactInvitations(
    charityId: string,
    status: CharityContactInvitationListStatusEnum | 'PENDING' | 'CANCELLED'
  ): Promise<AdminCharityContactInvitation[]> {
    const response = await this.request(
      print(GetCharityContactInvitationsGql),
      {
        charityId,
        status,
      } as QueryAdminCharityContactInvitationsArgs
    )

    const data = response.data as GetCharityContactInvitationsQuery

    return <AdminCharityContactInvitation[]>data.charityContactInvitations
  }

  async inviteCharityContact(input: InviteCharityContactInput): Promise<void> {
    await this.request(print(InviteCharityContactGql), { input })
  }

  async deactivateCharityContact(
    input: DeactivateCharityContactInput
  ): Promise<boolean> {
    const response = await this.request(print(DeactivateCharityContactGql), {
      input,
    })
    return response.data.deactivateCharityContact.success
  }

  async updateCharityContact(
    input: UpdateCharityContactInput
  ): Promise<boolean> {
    const response = await this.request(print(UpdateCharityContactGql), {
      input,
    })
    return response.data.updateCharityContact.success
  }

  async cancelCharityContactInvite(
    input: CancelCharityContactInviteInput
  ): Promise<boolean> {
    const response = await this.request(print(CancelCharityContactInviteGql), {
      input,
    })
    return response.data.cancelCharityContactInvite.success
  }

  async resendCharityContactInvite(
    input: ResendCharityContactInviteInput
  ): Promise<boolean> {
    const response = await this.request(print(ResendCharityContactInviteGql), {
      input,
    })

    return response.data.resendCharityContactInvite.success
  }

  async getCharityBankAccount(id: string): Promise<AdminCharityBankAccount> {
    const response = await this.request(print(GetCharityBankAccountGql), {
      id,
    } as QueryAdminCharityBankAccountArgs)
    return response.data.charityBankAccount
  }

  async getCharityBankAccounts(
    charityId: string,
    filters?: {
      status?: Array<
        'needs_review' | 'ready_for_verification_call' | 'verified' | 'rejected'
      >
      hasFlaggedChecklistItems?: boolean
      checklistIncomplete?: boolean
    }
  ): Promise<AdminCharityBankAccount[]> {
    const response = await this.request(print(GetCharityBankAccountsGql), {
      charityId,
      status: filters?.status ?? null,
      hasFlaggedChecklistItems: filters?.hasFlaggedChecklistItems,
      checklistIncomplete: filters?.checklistIncomplete,
    } as QueryAdminCharityBankAccountsArgs)
    return (response.data?.charityBankAccounts ??
      []) as AdminCharityBankAccount[]
  }

  async updateCharityBankAccountStatus(
    input: UpdateCharityBankAccountStatusInput
  ): Promise<AdminCharityBankAccount> {
    const response = await this.request(
      print(UpdateCharityBankAccountStatusGql),
      { input }
    )
    return response.data.updateCharityBankAccountStatus.bankAccount
  }

  async upsertCharityBankAccountChecklistItem(
    input: UpsertCharityBankAccountChecklistItemInput
  ): Promise<AdminCharityBankAccountChecklistItem> {
    const response = await this.request(
      print(UpsertCharityBankAccountChecklistItemGql),
      { input }
    )
    return response.data.upsertCharityBankAccountChecklistItem.checklistItem
  }

  async createCharityBankAccountVerificationCall(input: {
    charityBankAccountId: string
    callDateTime: string
    callOutcome: string
    organizationName?: string
    contactName?: string
    contactRole?: string
    telephoneNumberCalled?: string
    phoneNumberSource?: string
    emailAddressUsed?: string
    emailSource?: string
    identityConfirmationMethod?: string
    redFlagsPresent?: boolean
    redFlagsMitigationNotes?: string
    bankName?: string
    bankAddress?: string
    accountHolderName?: string
    accountHolderAddress?: string
    accountNumber?: string
    iban?: string
    abaRoutingNumber?: string
    sortCode?: string
    swiftCode?: string
    intermediaryBankDetails?: string
    intermediaryBankName?: string
    accountCurrency?: string
    comments?: string
    notes?: string
    preCallChecklist?: Record<string, unknown>
    duringCallChecklist?: Record<string, unknown>
  }): Promise<unknown> {
    const response = await this.request(
      print(CreateCharityBankAccountVerificationCallGql),
      { input }
    )
    return response.data?.createCharityBankAccountVerificationCall
      ?.verificationCall
  }

  async searchAssets(
    args: SearchAssetsQueryVariables
  ): Promise<SearchAssetsQuery['searchAssets']> {
    const response = await this.request(print(SearchAssetsGql), args)
    return (response.data as SearchAssetsQuery).searchAssets
  }

  // Needs VIEW_ASSETS
  async getEmployeeKit(
    employeeId: string
  ): Promise<GetEmployeeKitQuery['searchAssets']['collection']> {
    const response = await this.request(print(GetEmployeeKitGql), {
      employeeId,
    })
    return (response.data as GetEmployeeKitQuery).searchAssets.collection
  }

  async getAsset(id: string): Promise<AssetFieldsFragment> {
    const response = await this.request(print(GetAssetGql), { id })
    return (response.data as GetAssetQuery).asset
  }

  async getAssetDeviceCheckSummary(): Promise<
    GetAssetDeviceCheckSummaryQuery['assetDeviceCheckSummary']
  > {
    const response = await this.request(print(GetAssetDeviceCheckSummaryGql))
    return (response.data as GetAssetDeviceCheckSummaryQuery)
      .assetDeviceCheckSummary
  }

  async createAsset(
    args: CreateAssetMutationVariables
  ): Promise<AssetFieldsFragment> {
    const response = await this.request(print(CreateAssetGql), args)
    return (response.data as CreateAssetMutation).createAsset.asset
  }

  async createAssetsFromOrder(
    args: CreateAssetsFromOrderMutationVariables
  ): Promise<CreateAssetsFromOrderMutation['createAssetsFromOrder']['assets']> {
    const response = await this.request(print(CreateAssetsFromOrderGql), args)
    return (response.data as CreateAssetsFromOrderMutation)
      .createAssetsFromOrder.assets
  }

  async updateAsset(
    id: string,
    attributes: AssetAttributesInput
  ): Promise<AssetFieldsFragment> {
    const response = await this.request(print(UpdateAssetGql), {
      id,
      attributes,
    })
    return (response.data as UpdateAssetMutation).updateAsset.asset
  }

  async assignAsset(
    args: AssignAssetMutationVariables
  ): Promise<AssetFieldsFragment> {
    const response = await this.request(print(AssignAssetGql), args)
    return (response.data as AssignAssetMutation).assignAsset.asset
  }

  async returnAsset(
    args: ReturnAssetMutationVariables
  ): Promise<AssetFieldsFragment> {
    const response = await this.request(print(ReturnAssetGql), args)
    return (response.data as ReturnAssetMutation).returnAsset.asset
  }

  async changeAssetStatus(
    args: ChangeAssetStatusMutationVariables
  ): Promise<AssetFieldsFragment> {
    const response = await this.request(print(ChangeAssetStatusGql), args)
    return (response.data as ChangeAssetStatusMutation).changeAssetStatus.asset
  }

  async deleteAssetDocument(id: string): Promise<AssetFieldsFragment> {
    const response = await this.request(print(DeleteAssetDocumentGql), { id })
    return (response.data as DeleteAssetDocumentMutation).deleteAssetDocument
      .asset
  }

  async addAssetSecret(
    args: AddAssetSecretMutationVariables
  ): Promise<AssetFieldsFragment> {
    const response = await this.request(print(AddAssetSecretGql), args)
    return (response.data as AddAssetSecretMutation).addAssetSecret.asset
  }

  async revealAssetSecret(
    id: string,
    reason: string
  ): Promise<RevealAssetSecretMutation['revealAssetSecret']> {
    const response = await this.request(print(RevealAssetSecretGql), {
      id,
      reason,
    })
    return (response.data as RevealAssetSecretMutation).revealAssetSecret
  }

  async recordAssetCheck(
    args: RecordAssetCheckMutationVariables
  ): Promise<AssetFieldsFragment> {
    const response = await this.request(print(RecordAssetCheckGql), args)
    return (response.data as RecordAssetCheckMutation).recordAssetCheck.asset
  }

  async uploadAssetDocument(
    assetId: string,
    kind: AssetDocumentKindEnum,
    file: File
  ): Promise<{ id: string; kind: string; originalFilename: string }> {
    const formData = new FormData()
    // The upload endpoint takes the stored value, not the GraphQL enum name
    formData.append('kind', kind.toLowerCase())
    formData.append('file', file)

    const { token } = useAuth()
    const response = await appFetch(
      `/admin/assets/${encodeURIComponent(assetId)}/documents`,
      token.value ?? undefined,
      { method: 'POST', body: formData }
    )

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(message ?? `Upload failed: ${response.statusText}`)
    }

    return (await response.json()) as {
      id: string
      kind: string
      originalFilename: string
    }
  }

  async searchContracts(
    args: SearchContractsQueryVariables
  ): Promise<SearchContractsQuery['searchContracts']> {
    const response = await this.request(print(SearchContractsGql), args)
    return (response.data as SearchContractsQuery).searchContracts
  }

  async getContractSummary(): Promise<
    GetContractSummaryQuery['contractSummary']
  > {
    const response = await this.request(print(GetContractSummaryGql))
    return (response.data as GetContractSummaryQuery).contractSummary
  }

  async getContract(id: string): Promise<ContractFieldsFragment> {
    const response = await this.request(print(GetContractGql), { id })
    return (response.data as GetContractQuery).contract
  }

  async createContract(
    args: CreateContractMutationVariables
  ): Promise<ContractFieldsFragment> {
    const response = await this.request(print(CreateContractGql), args)
    return (response.data as CreateContractMutation).createContract.contract
  }

  async updateContract(
    args: UpdateContractMutationVariables
  ): Promise<ContractFieldsFragment> {
    const response = await this.request(print(UpdateContractGql), args)
    return (response.data as UpdateContractMutation).updateContract.contract
  }

  async recordContractRenewalDecision(
    args: RecordContractRenewalDecisionMutationVariables
  ): Promise<ContractFieldsFragment> {
    const response = await this.request(
      print(RecordContractRenewalDecisionGql),
      args
    )
    return (response.data as RecordContractRenewalDecisionMutation)
      .recordContractRenewalDecision.contract
  }

  async terminateContract(
    args: TerminateContractMutationVariables
  ): Promise<ContractFieldsFragment> {
    const response = await this.request(print(TerminateContractGql), args)
    return (response.data as TerminateContractMutation).terminateContract
      .contract
  }

  async deleteContractDocument(id: string): Promise<ContractFieldsFragment> {
    const response = await this.request(print(DeleteContractDocumentGql), {
      id,
    })
    return (response.data as DeleteContractDocumentMutation)
      .deleteContractDocument.contract
  }

  // Only a draft can be deleted; an active contract is terminated instead
  async deleteContract(id: string): Promise<string> {
    const response = await this.request(print(DeleteContractGql), { id })
    return (response.data as DeleteContractMutation).deleteContract.deletedId
  }

  async readContractDocumentAgain(id: string): Promise<ContractFieldsFragment> {
    const response = await this.request(print(ReadContractDocumentAgainGql), {
      id,
    })
    return (response.data as ReadContractDocumentAgainMutation)
      .readContractDocumentAgain.contract
  }

  // Creates a draft contract holding the file as its signed agreement, and queues its key terms to be read
  async startContractFromDocument(file: File): Promise<{
    contractId: string
    documentId: string
    readingKeyTerms: boolean
  }> {
    const formData = new FormData()
    formData.append('file', file)

    const { token } = useAuth()
    const response = await appFetch(
      '/admin/contracts/from-document',
      token.value ?? undefined,
      { method: 'POST', body: formData }
    )

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(message ?? `Upload failed: ${response.statusText}`)
    }

    const body = (await response.json()) as {
      contractId: number | string
      documentId: number | string
      readingKeyTerms: boolean
    }
    return {
      contractId: String(body.contractId),
      documentId: String(body.documentId),
      readingKeyTerms: body.readingKeyTerms,
    }
  }

  async uploadContractDocument(
    contractId: string,
    document: {
      kind: ContractDocumentKindEnum
      file: File
      title?: string
      datedOn?: string
      signed?: boolean
    }
  ): Promise<{ id: string; kind: string; originalFilename: string }> {
    const formData = new FormData()
    // The upload endpoint takes the stored value, not the GraphQL enum name
    formData.append('kind', document.kind.toLowerCase())
    formData.append('file', document.file)
    if (document.title) formData.append('title', document.title)
    if (document.datedOn) formData.append('dated_on', document.datedOn)
    if (document.signed === false) formData.append('signed', 'false')

    const { token } = useAuth()
    const response = await appFetch(
      `/admin/contracts/${encodeURIComponent(contractId)}/documents`,
      token.value ?? undefined,
      { method: 'POST', body: formData }
    )

    if (response.status === 401) {
      await useLogoutAndClearUserInfo(useAuth())
    }

    if (!response.ok) {
      const message = await this.tryParseJsonError(response)
      throw new Error(message ?? `Upload failed: ${response.statusText}`)
    }

    return (await response.json()) as {
      id: string
      kind: string
      originalFilename: string
    }
  }

  async getAssetReturns(
    includeCompleted = false
  ): Promise<GetAssetReturnsQuery['assetReturns']> {
    const response = await this.request(print(GetAssetReturnsGql), {
      includeCompleted,
    })
    return (response.data as GetAssetReturnsQuery).assetReturns
  }

  async setAssetExpectedReturn(
    assignmentId: string,
    expectedReturnMethod: AssetReturnMethodEnum
  ): Promise<SetAssetExpectedReturnMutation['setAssetExpectedReturn']['item']> {
    const response = await this.request(print(SetAssetExpectedReturnGql), {
      assignmentId,
      expectedReturnMethod,
    })
    return (response.data as SetAssetExpectedReturnMutation)
      .setAssetExpectedReturn.item
  }
}
